/* CN lade (eigen winkelwagen): opbouw, +/−, verwijderen, toevoegen, kassa-controle.
   Teksten en instellingen komen uit window.CN_CART (snippets/cart-custom.liquid).
   Geladen als module (uitgesteld, na het inlezen van de pagina); volgorde:
   cn-fees.js, cn-cadeau.js, daarna dit bestand. */
(() => {
  // ============================
  //  INIT GUARDS & CONFIG
  // ============================
  if (window.__customCartScriptLoaded) return;
  window.__customCartScriptLoaded = true;

  /* Teksten en instellingen uit Liquid: window.CN_CART in snippets/cart-custom.liquid. */
  const CFG = window.CN_CART || {};

  window.__cartLiteQueue ||= Promise.resolve();

  const OPEN_ON_ADD = true;
  const routes = window.Shopify?.routes?.root || '/';
  const XHR_HDRS = { 'X-Requested-With': 'XMLHttpRequest' };
  const EMPTY_CART_TITLE = CFG.emptyCartTitle || '';

  const CHECKOUT_LABEL_CUSTOM = CFG.checkoutLabelCustom || '';
  const FREE_GIFT_LABEL = CFG.freeGiftLabel || '';
  const PROCESSING_GIFT_LABEL = CFG.processingGiftLabel || '';
  const CHECKOUT_WAIT_LABEL = CFG.checkoutWaitLabel || '';
  const CHECKOUT_TIMEOUT_LABEL = CFG.checkoutTimeoutLabel || '';
  const CHECKOUT_NETWORK_ERROR_LABEL = CFG.checkoutNetworkErrorLabel || '';
  /* Failsafe-melding: gift kon niet gratis worden gemaakt → weggehaald,
     checkout gaat door. Kort zichtbaar op de knop vlak vóór de navigatie. */
  const CHECKOUT_GIFT_REMOVED_LABEL = CFG.checkoutGiftRemovedLabel || 'Cadeau niet beschikbaar, je gaat door';
  const CHECKOUT_LABEL_T = CFG.checkoutLabel || '';
  const ADD_ERROR_LABEL = CFG.addErrorLabel || '';
  const SHOP_LABEL = CFG.shopLabel || 'Shop';
  /* i18n-strings voor item-count display. Pluralized via Liquid → twee templates.
     JS vervangt __N__ placeholder met de actuele waarde (Liquid's | t filter
     vult count in de locale-string in met '__N__' string-literal,
     output bv. "(__N__) item"). */
  const ITEMS_COUNT_ONE = CFG.itemsCountOne || '(__N__)';
  const ITEMS_COUNT_OTHER = CFG.itemsCountOther || '(__N__)';
  function formatItemsCount(n) {
    var tpl = n === 1 ? ITEMS_COUNT_ONE : ITEMS_COUNT_OTHER;
    return tpl.replace('__N__', n);
  }

  // ============================
  //  HELPER: CHECK IF FREE GIFT
  // ============================
  /**
   * Gratis cadeau = een regel die €0 kost. Een cadeauregel (_cn_cadeau) die
   * nog de volle prijs heeft is géén gratis cadeau: de drempel is niet
   * gehaald en de cadeaumotor (snippets/cn-cadeau.liquid) haalt hem weg.
   */
  const isFreeGift = (item) => {
    return item.price === 0 || item.final_price === 0 || item.final_line_price === 0;
  };
  /* Cadeauregel van de cadeaumotor (ook als hij nog niet €0 is). */
  const isGiftLine = (item) => {
    const props = item?.properties || {};
    return props._cn_cadeau != null && props._cn_cadeau !== '';
  };

  // ============================
  //  ITEM GROUPING LOGIC
  // ============================
  const groupCartItems = (cart) => {
    if (!cart?.items?.length) return [];

    const groups = new Map();
    const result = [];
    const giftItems = [];

    for (const item of cart.items) {
      const isGift = isFreeGift(item);
      /* Plaatsing op de gift-MARKERING, niet op de prijs: een net
         toegevoegde gift waarvan de korting nog pending is (vol-prijs)
         hoort óók al onderaan — anders staat 'ie eerst bovenaan en
         springt 'ie naar beneden zodra de korting landt. 'checkout'-
         type blijft uitgesloten (geen display-gift).

         BEWUST GEEN known-gift-variant-heuristiek meer: als hetzelfde
         variant zowel BETAALD als gratis in de cart zit (bv. Gold Dry
         die je koopt én als gift krijgt), classificeerde die heuristiek
         óók de betaalde regel als gift → beide belanden in de gift-bucket
         in cart-volgorde, en omdat de gift eerder werd toegevoegd bleef
         die bovenaan staan. Het echte cadeau is betrouwbaar te herkennen
         aan prijs 0 (isGift) of het attribuut _cn_cadeau (isGiftMarked);
         dat is voldoende én veilig. */
      const isGiftMarked = isGiftLine(item);

      // Gratis items apart houden — worden onderaan geplaatst
      if (isGift || isGiftMarked) {
        giftItems.push({
          ...item,
          isGrouped: false,
          groupedKeys: [item.key],
          displayQuantity: item.quantity,
        });
        continue;
      }

      // Groepeer op variant_id + final_price
      const groupKey = `${item.variant_id}_${item.final_price}`;

      if (groups.has(groupKey)) {
        const group = groups.get(groupKey);
        group.groupedKeys.push(item.key);
        group.displayQuantity += item.quantity;
        group.final_line_price += item.final_line_price;
        group.original_line_price += item.original_line_price || 0;

        if (item.variant_compare_at_price) {
          group.variant_compare_at_price = item.variant_compare_at_price;
        }
        if (item.is_bundle_item) {
          group.is_bundle_item = true;
        }
      } else {
        const groupedItem = {
          ...item,
          isGrouped: true,
          groupedKeys: [item.key],
          displayQuantity: item.quantity,
        };
        groups.set(groupKey, groupedItem);
        result.push(groupedItem);
      }
    }

    // Free gifts altijd onderaan de cart
    return [...result, ...giftItems];
  };

  /* ============================
     DOM-ENFORCEMENT: gifts áltijd onderaan
     ============================
     Vangnet bovenop groupCartItems. groupCartItems ordent de JS-render
     al correct, maar er zijn paden waar een gift tóch tussen de betaalde
     items kan blijven staan:
      - de statische Liquid-paint (server-render) van een oud cadeau
        zonder marker dat op dat moment de volle prijs had;
      - een render vlak voordat de cadeaumotor zijn wijziging klaar had.
     Deze functie herordent puur op DOM-niveau: elke gift-rij naar het
     einde van het formulier, in hun onderlinge volgorde. Herkenning:
     rij-klasse, gouden-rand-marker, "Gratis"-prijs, of een bekende
     offer-gift-variant (dekt de nog-niet-gediscounte gift). Idempotent
     en goedkoop; verplaatst alleen wat niet al onderaan staat. */
  const cnEnforceGiftsLast = (root) => {
    const scope = root || cartItemsRoot;
    if (!scope) return;
    const form = scope.querySelector('#CartDrawer-Form') || scope;
    const rows = Array.from(form.children).filter(function (n) {
      return n.classList && n.classList.contains('cart-item');
    });
    if (rows.length < 2) return;
    /* Herkenning op ECHTE gift-status, niet op variant-identiteit: een
       betaalde regel van een variant dat óók als gift bestaat (bv. Gold
       Dry) mag NIET omlaag — zie de uitleg in groupCartItems. Signalen:
       gift-rij-klasse, gouden-rand-marker, of de "Gratis"-prijs. */
    const isGiftRow = (row) => {
      if (row.classList.contains('cart-item--fee')) return false;
      if (row.classList.contains('cart-item--free-gift')) return true;
      if (row.querySelector('.cart-item__image-container--free')) return true;
      const priceEl = row.querySelector('.cart-item__price-current');
      if (priceEl && priceEl.textContent.trim() === FREE_GIFT_LABEL) return true;
      return false;
    };
    const gifts = rows.filter(isGiftRow);
    if (!gifts.length) return;
    /* Al onderaan? (laatste N rijen zijn precies de gifts, in volgorde)
       → niets doen, voorkomt onnodige DOM-mutaties/reflow. */
    const tail = rows.slice(rows.length - gifts.length);
    let alreadyLast = tail.length === gifts.length;
    for (let i = 0; i < gifts.length && alreadyLast; i++) {
      if (tail[i] !== gifts[i]) alreadyLast = false;
    }
    if (alreadyLast) return;
    gifts.forEach(function (g) { form.appendChild(g); });
  };
  window.cnEnforceGiftsLast = cnEnforceGiftsLast;

  // ============================
  //  DOM CACHE
  // ============================
  const cartDrawer = document.getElementById('cart-custom');
  const cartBackdrop = document.getElementById('cart-custom-backdrop');
  const cartItemsContainer = document.getElementById('cart-custom-items-container');
  const cartItemsRoot = document.getElementById('CartDrawer-CartItems');
  const cartCount = document.getElementById('cart-custom-count');
  const cartTotal = document.getElementById('cart-custom-total');
  const cartSubtotal = document.getElementById('cart-custom-subtotal'); 
  const cartSubtotalCount = document.getElementById('cart-custom-subtotal-count');
  const cartDiscount = document.getElementById('cart-custom-discount');  
  const cartDiscountLine = document.getElementById('cart-discount-line');  
  const checkoutBtn = document.getElementById('cart-custom-checkout');
  const checkoutLabel = document.getElementById('cart-custom-cta-label');

  /* Spinner-element als eerste kind van de checkout-knop injecteren.
     Zichtbaar maken via .cn-checkout-waiting (zie CSS). DOM-element
     i.p.v. ::before zodat flex-order altijd correct is (theme btn-class
     gebruikt mogelijk row-reverse / order — dan komt ::before in het
     midden of rechts terecht). bag-icon wordt verborgen door dezelfde
     wait-class, spinner neemt z'n plek in. */
  if (checkoutBtn && !checkoutBtn.querySelector('.cn-checkout-spinner')) {
    const cnSpinnerEl = document.createElement('span');
    cnSpinnerEl.className = 'cn-checkout-spinner';
    cnSpinnerEl.setAttribute('aria-hidden', 'true');
    checkoutBtn.insertBefore(cnSpinnerEl, checkoutBtn.firstChild);
  }
  const closeBtn = cartDrawer.querySelector('.cart-custom-close');
  const cartItemTemplate = document.getElementById('cart-item-template');

  // ============================
  //  HELPERS
  // ============================
  /* In de valuta van de klant, zelfde opmaak als Liquid (cnMoney in cart-custom.liquid). */
  const formatMoney = (cents) => (typeof window.cnMoney === 'function'
    ? window.cnMoney(cents)
    : `€${(cents / 100).toFixed(2).replace('.', ',')}`);

  /* Kortingsprijzen vooraf tonen: chip op regels met zo'n korting.
     Herkenning op de titel van de automatische korting: die staat in
     prelaunch.kortingen.titels ('|early access 7%|...|', kleine letters),
     gevuld door scripts/predisplay-sync.mjs. */
  const PRELAUNCH_ON = CFG.prelaunchOn === true;
  const PRELAUNCH_TITELS = CFG.prelaunchTitels || '';
  const PRELAUNCH_BADGE_HTML = CFG.prelaunchBadgeHtml || '';
  const lineHasPrelaunch = (item) => PRELAUNCH_ON && PRELAUNCH_TITELS.length > 0
    && Array.isArray(item.line_level_discount_allocations)
    && item.line_level_discount_allocations.some((a) => PRELAUNCH_TITELS.indexOf('|' + (((a && a.discount_application && a.discount_application.title) || '').toLowerCase()) + '|') !== -1);

  let lastCartFetchTime = 0;
  let lastCartResult = null;
  const CART_FETCH_MIN_INTERVAL = 300;

  async function fetchCart(enrich = false) {
    const now = Date.now();
    if (now - lastCartFetchTime < CART_FETCH_MIN_INTERVAL && lastCartResult) {
      return enrich ? await enrichCartItems(structuredClone(lastCartResult)) : structuredClone(lastCartResult);
    }

    try {
      const response = await fetch(`${routes}cart.js`, { headers: XHR_HDRS });
      if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);

      const cart = await response.json();
      window.cartCurrency = cart.currency || cart.currency_code || window.Shopify?.currency?.active || 'EUR';

      lastCartFetchTime = Date.now();
      lastCartResult = cart;
      rememberCartSeen(cart);

      return enrich ? await enrichCartItems(cart) : cart;
    } catch (err) {
      console.error('fetchCart error:', err);
      return null;
    }
  }

  /* Het antwoord van /cart/change.js is de hele winkelwagen: die nemen we
     direct over, zonder /cart.js nog een keer op te halen. */
  async function adoptCart(cart, enrich = false) {
    if (!cart || !Array.isArray(cart.items)) return fetchCart(enrich);
    window.cartCurrency = cart.currency || window.cartCurrency || 'EUR';
    lastCartFetchTime = Date.now();
    lastCartResult = cart;
    rememberCartSeen(cart);
    return enrich ? await enrichCartItems(structuredClone(cart)) : structuredClone(cart);
  }

  /* Laatst geziene winkelwagen in dit tabblad (aantal, totaal, regels). Bij
     het laden van een pagina vergelijken we die met de winkelwagen uit
     Liquid: gelijk, dan hoeft de lade niets op te halen. Een vooraf geladen
     pagina (het thema laadt links al bij aanwijzen) kan een oudere
     winkelwagen bevatten dan wat dit tabblad intussen zag; dan wel ophalen. */
  const CART_SEEN_KEY = 'cn_cart_seen_v1';
  function cartSig(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    return cart.item_count + '|' + cart.total_price + '|' + cart.items.map((i) => i.key + ':' + i.quantity).join(',');
  }
  function rememberCartSeen(cart) {
    const sig = cartSig(cart);
    if (!sig) return;
    try { sessionStorage.setItem(CART_SEEN_KEY, sig); } catch (e) { /* zonder geheugen halen we gewoon op */ }
  }
  document.addEventListener('cart:updated', (e) => rememberCartSeen(e && e.detail && e.detail.cart));
  /* Elke wijziging van regels of kortingscode, ook door de winkelwagenpagina
     of een app, maakt die stand onzeker tot we de winkelwagen zelf weer zien.
     Alleen kenmerken of een notitie zetten (bv. Analyzify) telt niet. */
  function cartWriteMatters(url, input, init) {
    if (/\/cart\/(add|change|clear)/.test(url)) return true;
    if (!/\/cart\/update/.test(url)) return false;
    if (input && typeof input === 'object' && typeof input.url === 'string') return true;
    if (/[?&](updates|discount)/.test(url)) return true;
    const body = init && init.body;
    if (body == null) return false;
    if (typeof body === 'string') return /updates|discount/.test(body);
    if (typeof body.forEach === 'function' && typeof body.get === 'function') {
      let hit = false;
      body.forEach((v, k) => { if (/^(updates|discount)/.test(String(k))) hit = true; });
      return hit;
    }
    return true;
  }
  try {
    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        const url = typeof input === 'string' ? input : ((input && input.url) || String(input || ''));
        if (cartWriteMatters(url, input, init)) sessionStorage.setItem(CART_SEEN_KEY, 'onzeker');
      } catch (e) { /* nooit een verzoek breken */ }
      return origFetch.apply(this, arguments);
    };
  } catch (e) { /* zonder deze wrap haalt de lade bij twijfel gewoon op */ }

  /* CN Fees: statiegeld-regels tellen niet mee als "artikel" in de
     tellers (badge + drawer-header). Valt terug op item_count als de
     fee-engine (nog) niet geladen is. */
  const cnDisplayItemCount = (cart) => {
    let count = Math.max(0, cart?.item_count ?? 0);
    try {
      if (typeof window.cnIsFeeLine === 'function') {
        (cart?.items || []).forEach(function (it) {
          if (window.cnIsFeeLine(it)) count -= it.quantity;
        });
      }
    } catch (e) { /* teller mag nooit breken */ }
    return Math.max(0, count);
  };

  /* CN Fees: fee-sync mee onder dezelfde loading-overlay als de cart-
     mutatie zelf — product en statiegeld verschijnen dan in ÉÉN render
     (i.p.v. product eerst en het statiegeld ~1s later los erachteraan).
     Kost níéts wanneer er geen fee-wijziging nodig is (pure vergelijking
     op de meegegeven cart, geen netwerk). Bij een wijziging: sync +
     één verse (enriched) fetch. Faalt de sync, dan herstelt de reguliere
     engine-trigger het alsnog een tel later. */
  const cnEnsureFeesBeforeRender = async (cart) => {
    try {
      if (typeof window.cnFeesEnsure !== 'function' || !cart || !cart.items) return cart;
      /* Mutatie-teller vóór/na: her-fetch óók als een PARALLELLE engine-sync
         het statiegeld toevoegde terwijl wij awaitten (dan geeft cnFeesEnsure
         zelf misschien 'false' terug, maar de teller liep op). Zo verschijnt
         het statiegeld gegarandeerd in dezélfde render als het product en
         niet 1s later. */
      const seqBefore = window.cnFeesMutationSeq || 0;
      const changed = await window.cnFeesEnsure(cart, { silent: true });
      const seqAfter = window.cnFeesMutationSeq || 0;
      if (changed || seqAfter !== seqBefore) {
        lastCartFetchTime = 0;
        const fresh = await fetchCart(true);
        if (fresh) return fresh;
      }
    } catch (e) { /* engine-heartbeat corrigeert alsnog */ }
    return cart;
  };

  const updateCartCountInHeader = (cart) => {
    const badge = document.getElementById('CartCount');
    if (!badge) return;

    const count = cnDisplayItemCount(cart);

    if (count === 0) {
      badge.innerHTML = '';
      return;
    }

    let wrap = badge.querySelector('.cart-count');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'cart-count';
      badge.appendChild(wrap);
    }

    /* Het zichtbare getal werd hier nooit gezet: er kwam een lege
       .cart-count in de header en alleen de screenreader-tekst werd
       gevuld. Was de winkelwagen leeg bij pageload, dan rendert Liquid
       nog geen bolletje, dus maakte deze functie er een zwarte stip
       zonder cijfer van. Bestond het bolletje al server-side, dan bleef
       het oude aantal staan. Zelfde markup als in header-custom-empty
       en cart-drawer, zodat de opmaak niet verspringt. */
    let num = wrap.querySelector('span[aria-hidden]');
    if (!num) {
      num = document.createElement('span');
      num.setAttribute('aria-hidden', 'true');
      wrap.appendChild(num);
    }
    num.textContent = count;
    wrap.classList.toggle('cart-count--ellipse', count > 9);

    let sr = badge.querySelector('.visually-hidden');
    if (!sr) {
      sr = document.createElement('span');
      sr.className = 'visually-hidden';
      badge.appendChild(sr);
    }
    sr.textContent = formatItemsCount(count);
  };

  const updateCheckoutCTA = (cart) => {
    if (!checkoutBtn || !checkoutLabel) return;

    const hasItems = (cart?.item_count || 0) > 0;

    checkoutBtn.dataset.cta = hasItems ? 'checkout' : 'shop';
    checkoutBtn.classList.toggle('is-shop', !hasItems);
    checkoutBtn.classList.toggle('is-checkout', hasItems);

    /* Wacht-stand van de knop (spinner, niet klikbaar) zolang de
       cadeaumotor bezig is (window.cnAddInFlight) of er een cadeauregel
       op volle prijs staat. Dat laatste duurt hooguit een tel: de motor
       haalt zo'n regel meteen weg. Niet overschrijven als de klik-flow
       zelf al bezig is. */
    const cartHasPendingGift = hasItems && Array.isArray(cart?.items)
      && cart.items.some((item) => {
        const hasNonZeroPrice = (item.final_price > 0) || (item.final_line_price > 0);
        return isGiftLine(item) && hasNonZeroPrice;
      });
    const inBogosWait = cartHasPendingGift || window.cnAddInFlight === true;
    if (checkoutBtn.dataset.cnCheckoutGuard !== 'busy') {
      checkoutBtn.classList.toggle('cn-checkout-waiting', inBogosWait);
      checkoutBtn.setAttribute('aria-busy', inBogosWait ? 'true' : 'false');
    }

    /* Express-knoppen (Apple Pay, Shop Pay) blokkeren zolang er een
       cadeau op volle prijs in de cart staat: die omzeilen onze
       checkout-controle. Body-class, zodat het elke plek dekt waar
       Shopify zulke knoppen neerzet. */
    try { document.body.classList.toggle('cn-gift-pending-global', !!inBogosWait); } catch (e) {}

    const finalLabel = hasItems
      ? (CHECKOUT_LABEL_CUSTOM || CHECKOUT_LABEL_T)
      : SHOP_LABEL;

    checkoutLabel.textContent = finalLabel;
  };

  /* Catalogus- en vanafprijs per variant. Die veranderen niet tijdens een
     bezoek, dus de cache blijft staan (vroeger werd hij bij elke actie
     geleegd en haalde elke +/- alle varianten opnieuw op). De varianten die
     al in de winkelwagen zaten, komen meteen uit Liquid (CN_CART.variants). */
  const variantCache = new Map();
  Object.keys(CFG.variants || {}).forEach((id) => {
    const v = CFG.variants[id];
    if (Array.isArray(v)) variantCache.set(Number(id), { price: v[0], compare_at_price: v[1] });
  });
  const fetchVariantDetails = async (variantId) => {
    if (!variantId) return null;
    
    if (variantCache.has(variantId)) {
      return variantCache.get(variantId);
    }

    try {
      const res = await fetch(`${routes}variants/${variantId}.js`, { headers: XHR_HDRS });
      if (!res.ok) throw new Error(`Variant fetch failed: ${res.status}`);

      const variant = await res.json();
      const price = variant?.price ?? 0;
      const compare = variant?.compare_at_price ?? null;

      const result = {
        ...variant,
        price_parsed: price,
        compare_at_price_parsed: compare
      };
      
      variantCache.set(variantId, result);
      return result;
    } catch (err) {
      console.error('Variant API error:', err);
      return null;
    }
  };

  const enrichCartItems = async (cart) => {
    if (!cart?.items?.length) return cart;

    /* Hard timeout op de variant-enrichment fase: max 700ms voor
       álle variant-detail fetches samen. Voorheen wachtte de cart-
       render op de TRAAGSTE /variants/{id}.js call (Promise.all),
       wat op trager netwerk vaak 1-2s opleverde. Sinds de cache blijft
       staan, wacht alleen een net toegevoegde variant hier nog op.
       Beter half-enriched renderen dan 2 seconden lege spinner. */
    const enrichPromises = cart.items.map(async (item) => {
      /* Cadeauregels niet verrijken: hun prijs komt van Shopify (€0 via de
         Cadeau korting of via de cart transform) en mag nooit terug naar de
         catalogusprijs, anders denkt de cadeaumotor dat het cadeau geld
         kost. De doorgestreepte waarde komt uit cnCadeau.listPrice. */
      if (isGiftLine(item)) return;

      const hasLineLevelDiscount =
        item.line_level_discount_allocations &&
        item.line_level_discount_allocations.length > 0;

      const hasDiscountedPrice = item.price > item.final_price;

      if (hasLineLevelDiscount || hasDiscountedPrice) {
        item.variant_compare_at_price = item.price;
        item.is_bundle_item = true;
      } else if (item.variant_id) {
        const variantDetails = await fetchVariantDetails(item.variant_id);
        /* Alleen als de winkelwagen de gewone catalogusprijs rekent: een
           prijs die een cart transform heeft aangepast, laten we staan. */
        if (variantDetails && Number(item.original_price) === Number(variantDetails.price)) {
          if (variantDetails.compare_at_price && variantDetails.compare_at_price > variantDetails.price) {
            item.variant_compare_at_price = variantDetails.compare_at_price;
            item.price = variantDetails.price;
            item.final_price = variantDetails.price;
            item.final_line_price = variantDetails.price * item.quantity;
          }
        }
      }


    });

    // Race tegen 700ms timeout — items die niet op tijd enriched
    // zijn worden gewoon zonder compare_at_price gerenderd. Dat is
    // visueel niet ideaal (geen doorgestreepte prijs op die items)
    // maar miljoenen keren beter dan 5 seconden naar een spinner
    // kijken. enrichCartItems wordt ook door background-polls
    // gebruikt — die kunnen wel volle enrichment afmaken.
    await Promise.race([
      Promise.all(enrichPromises),
      new Promise(resolve => setTimeout(resolve, 700)),
    ]);
    return cart;
  };

  const calculateCartTotals = (cart) => {
    if (!cart?.items?.length) return { subtotal: 0, discount: 0, total: 0 };

    let subtotal = 0;
    
    for (const item of cart.items) {
      /* Cadeau op €0 via de prijs (cart transform): de waarde telt mee in
         het doorgestreepte totaal, net als bij een cadeau via korting. */
      if (isGiftLine(item) && !(item.price > 0) && window.cnCadeau && typeof window.cnCadeau.listPrice === 'function') {
        subtotal += (window.cnCadeau.listPrice(item) || 0) * item.quantity;
        continue;
      }
      if (item.variant_compare_at_price && item.variant_compare_at_price > item.price) {
        subtotal += item.variant_compare_at_price * item.quantity;
      } else {
        subtotal += item.price * item.quantity;
      }
    }

    const total = cart.total_price;
    const discount = subtotal - total;

    return {
      subtotal: subtotal,
      discount: discount > 0 ? discount : 0,
      total: total
    };
  };

  const updateCartTotals = (cart) => {
    const { subtotal, discount, total } = calculateCartTotals(cart);

    if (cartSubtotal) cartSubtotal.textContent = formatMoney(subtotal);
    if (cartTotal) cartTotal.textContent = formatMoney(total);

    // Compare-at totaal (grijs doorgestreept achter de prijs).
    // We nemen de HOOGSTE van: de compare-at "was"-prijs (subtotal,
    // dekt sale/compare_at items) én cart.original_total_price (dekt
    // cart-level / BOGOS / line-kortingen). Zo komt het overeen met
    // wat de cart-pagina toont — niet "alleen op de cart page".
    const cnCompareEl = document.getElementById('cart-custom-compare');
    if (cnCompareEl) {
      const cnCompareBase = Math.max(subtotal, cart.original_total_price || 0);
      if (cnCompareBase > total) {
        cnCompareEl.textContent = formatMoney(cnCompareBase);
        cnCompareEl.style.display = '';
      } else {
        cnCompareEl.style.display = 'none';
      }
    }

    // Goudstaven — zelfde formule als PDP: round(euro * 9).
    const cnGoudEl = document.getElementById('cart-custom-goudstaven');
    if (cnGoudEl) cnGoudEl.textContent = Math.round((total / 100) * 9);
    
    if (cartDiscountLine && cartDiscount) {
      if (discount > 0) {
        cartDiscountLine.style.display = 'flex';
        cartDiscount.textContent = `-${formatMoney(discount)}`;
      } else {
        cartDiscountLine.style.display = 'none';
      }
    }
  };

  const getEmptyStateHTML = async () => {
    const tpl = document.getElementById('cart-empty-template');
    if (tpl && 'content' in tpl) {
      const frag = tpl.content.cloneNode(true);
      const div = document.createElement('div');
      div.appendChild(frag);
      return div.innerHTML;
    }

    try {
      const res = await fetch(`${routes}?section_id=cart-empty-render`, { headers: XHR_HDRS });
      if (!res.ok) throw new Error(`Failed to load empty state: ${res.status}`);
      return await res.text();
    } catch (err) {
      console.error(err);
      return `<div class="cart-custom-empty"><p>${EMPTY_CART_TITLE}</p></div>`;
    }
  }; 

  const renderEmptyState = async () => {
    /* Idempotent: als de empty-state al gerenderd is, niets te doen.
       Voorheen zorgde dit voor extra flikkers — BOGOS' Mutation­Observer
       vuurt ~1200ms na een mutation een nieuwe cart-fetch + updateCartUI,
       en als de cart nog steeds leeg is roept die opnieuw render­EmptyState
       aan. Elke aanroep speelde de fade-cyclus → 2-3 flashes op rij. Nu
       exit'en we vroeg als 't al goed staat. */
    if (cartItemsRoot.querySelector('.cart-custom-empty')) {
      return;
    }

    const html = await getEmptyStateHTML();

    /* Smoothere overgang naar empty-state: fade-out → swap → pre-
       decode images → fade-in. Voorkomt de "rushed flash" wanneer
       het laatste item wordt verwijderd en de empty-state met de
       collection-card afbeeldingen ineens pop't. */
    const FADE_MS = 180;
    cartItemsRoot.style.transition = `opacity ${FADE_MS}ms ease`;
    cartItemsRoot.style.opacity = '0';
    await new Promise(r => setTimeout(r, FADE_MS));

    cartItemsRoot.innerHTML = html;

    // Pre-decode images met 300ms ceiling — zelfde reden als in
     // renderCartItems: niet eindeloos wachten op trage decodes.
    const imgs = cartItemsRoot.querySelectorAll('img');
    if (imgs.length) {
      await Promise.race([
        Promise.all(Array.from(imgs).map(img =>
          img.decode ? img.decode().catch(() => {}) : Promise.resolve()
        )),
        new Promise(resolve => setTimeout(resolve, 300)),
      ]);
    }

    cartItemsRoot.style.opacity = '1';
    // Cleanup transition na de fade-in zodat latere DOM-ops geen
    // ongewenste transitie meekrijgen.
    setTimeout(() => {
      cartItemsRoot.style.transition = '';
    }, FADE_MS + 50);
  };

  // ============================
  //  RENDERING
  // ============================
  const getLinePrice = (item) => {
    const qty = Number.isFinite(item?.displayQuantity) 
      ? item.displayQuantity 
      : (Number.isFinite(item?.quantity) ? item.quantity : 1);
    
    if (Number.isFinite(item?.final_line_price) && item.final_line_price > 0) {
      return item.final_line_price;
    }
    if (Number.isFinite(item?.final_price) && item.final_price > 0) {
      return item.final_price * qty;
    }
    if (Number.isFinite(item?.price)) {
      return item.price * qty;
    }
    return 0;
  };

  /* Cadeaurijen die er bij de vorige weergave nog niet waren, schuiven zacht
     in beeld (klasse cart-item--enter, CSS in assets/snippet-cart-custom.css). null =
     nog geen weergave geweest: dan niets animeren. */
  let cnPrevGiftKeys = null;
  let cnNextGiftKeys = new Set();

  const createCartItemFromTemplate = (item) => {
    const template = cartItemTemplate.content.cloneNode(true);
    const el = template.querySelector('.cart-item');
    const hasVariant = item.variant_title && item.variant_title !== 'Default Title';

    // Gebruik eerste key als display key, sla alle keys op voor grouped items
    const displayKey = item.groupedKeys?.[0] || item.key;
    el.dataset.itemKey = displayKey;
    el.dataset.groupedKeys = JSON.stringify(item.groupedKeys || [item.key]);
    el.dataset.isGrouped = String(item.isGrouped || false);
    /* CN Fees: product-id op de rij zodat fee-add-ons hun moederproduct
       kunnen vinden (cnAttachFeeAddons). */
    if (item.product_id) el.dataset.productId = String(item.product_id);
    /* Variant-id op de rij zodat de DOM-enforcement (cnEnforceGiftsLast)
       óók een nog-niet-gediscounte gift (vol-prijs, geen gift-property)
       als gift kan herkennen via de bekende offer-gift-varianten. */
    if (item.variant_id) el.dataset.variantId = String(item.variant_id);

    /* Een cadeauregel die (heel even) nog de volle prijs heeft, tonen we
       als cadeau met een laad-rondje i.p.v. de prijs; de cadeaumotor haalt
       hem meteen weg als de drempel niet gehaald is. */
    const isGift = isFreeGift(item) || isGiftLine(item);
    /* Placement-markering: gift-rijen krijgen een rij-klasse zodat de
       DOM-enforcement ze onderaan houdt, ongeacht welk render-pad liep. */
    if (isGift) {
      el.classList.add('cart-item--free-gift');
      cnNextGiftKeys.add(displayKey);
      if (cnPrevGiftKeys && !cnPrevGiftKeys.has(displayKey)) el.classList.add('cart-item--enter');
    }

    /* CN Fees: statiegeld-regels compact en read-only renderen — geen
       qty-knoppen of prullenbak (de fee-engine beheert de aantallen;
       handmatig wijzigen wordt toch direct teruggecorrigeerd). */
    const isFeeLine = (typeof window.cnIsFeeLine === 'function') && window.cnIsFeeLine(item);
    if (isFeeLine) el.classList.add('cart-item--fee');

    const imgContainer = el.querySelector('.cart-item__image-container');
    if (isGift) {
      /* Alleen de gouden gradient-border markeert nu een gratis item;
         de losse "GRATIS CADEAU" tekst-badge was visueel dubbel op
         met het rode "Gratis" prijslabel. */
      imgContainer.classList.add('cart-item__image-container--free');
    }

    const img = el.querySelector('.cart-item__image');
    if (item.image) {
      img.src = item.image;
      img.alt = item.title;
    } else {
      img.parentElement.style.display = 'none';
    }

    const link = el.querySelector('.cart-item__name a');
    link.href = item.url;
    link.textContent = item.product_title;

    const variantEl = el.querySelector('.cart-item__options');
    // Vaste bundelcomponenten (uit de server-side map) — géén optie-as in
    // cart.js, dus komen ze alleen hiervandaan.
    const cnExtras = (window.cnBundleExtras || {})[item.product_id];
    const cnHasExtras = Array.isArray(cnExtras) && cnExtras.length > 0;
    const cnAppendExtras = function (target) {
      if (!cnHasExtras) return;
      for (let i = 0; i < cnExtras.length; i++) {
        const c = cnExtras[i];
        const t = c.title || c.productTitle;
        if (!t) continue;
        let v = c.variant || c.variantTitle;
        if (v === 'Default Title') v = '';
        const q = c.quantity || 1;
        const line = document.createElement('div');
        line.className = 'cart-item__option-line cart-item__option-line--bundle-extra';
        line.textContent = q + '× ' + t + (v ? ' · ' + v : '');
        target.appendChild(line);
      }
    };

    if (hasVariant && item.options_with_values?.length) {
      // Bundel-detectie spiegelt de Liquid-render: product_type bevat
      // een bundle-keyword (of requires_components indien aanwezig).
      const bundleKw = ['bundel', 'bundle', 'coaching', 'pack', 'pakket'];
      const ptype = (item.product_type || '').toLowerCase();
      const isBundle =
        bundleKw.some(function (k) { return ptype.indexOf(k) !== -1; }) ||
        item.requires_components === true;

      variantEl.classList.toggle('cart-item__options--bundle', isBundle || cnHasExtras);

      if (isBundle) {
        // AFSPRAAK — bundel: alle gekozen opties op één regel, " | ".
        const line = document.createElement('div');
        line.className = 'cart-item__option-line';
        line.textContent = item.options_with_values
          .map(function (ov) { return ov.name + ' - ' + ov.value; })
          .join(' | ');
        variantEl.replaceChildren(line);
      } else {
        // Geen bundel → opties gewoon onder elkaar.
        const frag = document.createDocumentFragment();
        for (let i = 0; i < item.options_with_values.length; i++) {
          const ov = item.options_with_values[i];
          const line = document.createElement('div');
          line.className = 'cart-item__option-line';
          line.textContent = ov.name + ' - ' + ov.value;
          frag.appendChild(line);
        }
        variantEl.replaceChildren(frag);
      }
      // Vaste componenten als losse regels onder de gekozen opties.
      cnAppendExtras(variantEl);
    } else if (cnHasExtras) {
      // Geen optie-assen (bv. pack zonder keuze) maar wél vaste componenten.
      variantEl.classList.add('cart-item__options--bundle');
      variantEl.replaceChildren();
      cnAppendExtras(variantEl);
    } else {
      variantEl.remove();
    }

    const currentPriceEl = el.querySelector('.cart-item__price-current');
    const comparePriceEl = el.querySelector('.cart-item__price-compare');
    const discountBadgeEl = el.querySelector('.cart-item__discount-badge');
    /* Zichtbaar ook als klasse: de CSS kleurt de prijs rood via
       :has(.cart-item__price-compare.is-zichtbaar), niet via [style]. */
    const toonCompare = (aan) => {
      comparePriceEl.style.display = aan ? 'inline' : 'none';
      comparePriceEl.classList.toggle('is-zichtbaar', aan);
    };

    /* Onderscheid tussen "écht gratis" (final_price === 0) en een
       cadeauregel die nog de volle prijs heeft (drempel net niet
       gehaald; de cadeaumotor haalt hem zo weg). Die laatste krijgt een
       laad-rondje i.p.v. "Gratis", zodat de klant nooit "Gratis" ziet
       bij een regel die geld kost. */
    const giftIsActuallyFree = item.final_price === 0
      || item.final_line_price === 0
      || item.price === 0;
    if (isGift && giftIsActuallyFree) {
      currentPriceEl.textContent = FREE_GIFT_LABEL;
      currentPriceEl.classList.remove('cart-item__price-current--processing');
    } else if (isGift) {
      /* Spinner i.p.v. "Verwerken…" tekst; PROCESSING_GIFT_LABEL blijft
         beschikbaar voor screen readers via aria-label. Idempotent
         ingevoegd zodat re-renders de animatie niet herstarten. */
      if (!currentPriceEl.querySelector('.cart-item__price-spinner')) {
        currentPriceEl.textContent = '';
        var spinner = document.createElement('span');
        spinner.className = 'cart-item__price-spinner';
        spinner.setAttribute('role', 'status');
        spinner.setAttribute('aria-label', PROCESSING_GIFT_LABEL);
        currentPriceEl.appendChild(spinner);
      }
      currentPriceEl.classList.add('cart-item__price-current--processing');
    } else {
      currentPriceEl.textContent = formatMoney(getLinePrice(item));
      currentPriceEl.classList.remove('cart-item__price-current--processing');
    }

    // Gebruik displayQuantity voor grouped items
    const displayQty = item.displayQuantity || item.quantity;

    let compareAtLinePrice = null;
    
    if (item.is_bundle_item && item.variant_compare_at_price) {
      compareAtLinePrice = item.variant_compare_at_price * displayQty;
    } else if (item.variant_compare_at_price && item.variant_compare_at_price > item.price) {
      compareAtLinePrice = item.variant_compare_at_price * displayQty;
    } else if (item.original_line_price && item.original_line_price > item.final_line_price) {
      compareAtLinePrice = item.original_line_price;
    }

    const hasValidCompare = compareAtLinePrice && compareAtLinePrice > 0;
    const hasPositiveFinal = item.final_line_price > 0;
    const shouldShowDiscount = !isGift && hasValidCompare && hasPositiveFinal && compareAtLinePrice > item.final_line_price;

    if (shouldShowDiscount) {
      comparePriceEl.textContent = formatMoney(compareAtLinePrice);
      toonCompare(true);

      const discountAmount = compareAtLinePrice - item.final_line_price;
      const discountPercentage = Math.round((discountAmount / compareAtLinePrice) * 100);
      discountBadgeEl.textContent = `-${discountPercentage}%`;
      discountBadgeEl.style.display = 'inline-block';
    } else if (isGift) {
      /* Gift → de waarde doorgestreept tonen. Dit toont de €X ÉN maakt
         "Gratis" rood (CSS kleurt price-current rood zodra de compare
         zichtbaar is). De compare komt uit variant_compare_at_price, anders
         uit de eigen prijs van het item, zodat de rode "Gratis €X"-layout
         meteen compleet verschijnt. */
      var giftCompare = (hasValidCompare && compareAtLinePrice)
        ? compareAtLinePrice
        : (item.price * displayQty);
      /* Cadeau op €0 via de prijs (cart transform): de winkelwagen rekent
         0, dus de catalogusprijs komt uit de cadeaumotor. */
      if (!(giftCompare > 0) && window.cnCadeau && typeof window.cnCadeau.listPrice === 'function') {
        var cnListPrice = window.cnCadeau.listPrice(item);
        if (cnListPrice) giftCompare = cnListPrice * displayQty;
      }
      if (giftCompare > 0) {
        comparePriceEl.textContent = formatMoney(giftCompare);
        toonCompare(true);
      } else {
        toonCompare(false);
      }
      discountBadgeEl.style.display = 'none';
    } else {
      toonCompare(false);
      discountBadgeEl.style.display = 'none';
    }

    const prelaunchEl = el.querySelector('.cart-item__prelaunch-badge');
    if (prelaunchEl) {
      if (!isGift && lineHasPrelaunch(item)) {
        if (!prelaunchEl.innerHTML) prelaunchEl.innerHTML = PRELAUNCH_BADGE_HTML;
        prelaunchEl.hidden = false;
      } else {
        prelaunchEl.hidden = true;
      }
    }

    const removeBtn = el.querySelector('.cart-item__remove');
    const minusBtn = el.querySelector('[data-quantity-minus]');
    const plusBtn = el.querySelector('[data-quantity-plus]');
    const qtyInput = el.querySelector('[data-quantity-input]');

    if (removeBtn) {
      removeBtn.dataset.removeItem = displayKey;
      removeBtn.setAttribute('aria-label', `Remove ${item.title}`);
    }
    if (minusBtn) {
      minusBtn.dataset.quantityMinus = displayKey;
      minusBtn.disabled = false;
    }
    if (plusBtn) {
      plusBtn.dataset.quantityPlus = displayKey;
      plusBtn.disabled = false;
    }
    if (qtyInput) {
      // Pending optimistische waarde heeft voorrang zolang een update
      // voor deze key loopt → het getal blijft staan, geen bounce.
      qtyInput.value = (displayKey in cnPendingQty) ? cnPendingQty[displayKey] : displayQty;
      qtyInput.dataset.quantityInput = displayKey;
      qtyInput.setAttribute('aria-label', `Quantity for ${item.product_title}`);
    }

    if (isGift) {
      const controlsWrapper = el.querySelector('.cart-item__controls');
      if (controlsWrapper) controlsWrapper.style.display = 'none';
      /* Remove-knop BLIJFT zichtbaar als failsafe: kleinere visuele
         prominentie via .cart-item__remove--free modifier (CSS) zodat
         'ie niet om aandacht schreeuwt maar de klant er altijd vanaf
         kan als de cart in een mismatch-staat zit. */
      if (removeBtn) {
        removeBtn.classList.add('cart-item__remove--free');
        removeBtn.setAttribute('aria-label', 'Verwijder gratis cadeau ' + (item.title || ''));
      }
    } else if (removeBtn) {
      removeBtn.classList.remove('cart-item__remove--free');
    }

    return el;
  };

  const updateCartUI = (cart, changedKey = null, isRemoval = false, isAddition = false, options = {}) => {
    const { forceFullRender = false } = options;

    const cnHeaderCount = cnDisplayItemCount(cart);
    const itemCountText = cnHeaderCount > 0 ? formatItemsCount(cnHeaderCount) : '';
    
    cartCount.textContent = itemCountText;
    
    if (cartSubtotalCount) {
      cartSubtotalCount.textContent = itemCountText;
    }

    updateCartTotals(cart);
    updateCheckoutCTA(cart);

    /* Cadeaus bijwerken voor deze stand (niet-blokkerend). Elke weg
       waarlangs de lade rendert komt hier langs, dus ook wijzigingen
       van buiten de lade (bundel-app, cart-page) worden zo opgepakt. */
    try { if (window.cnCadeau) window.cnCadeau.check(cart); } catch (e) {}
    /* Cart-koopjes bij elke weergave bijwerken (assets/cn-koopjes.js). */
    try { if (window.cnKoopjes) window.cnKoopjes.render(cart); } catch (e) {}

    if (cart.item_count === 0) {
      /* Lege cart = schone lei: een eerder geweigerd cadeau mag bij een
         nieuwe bestelling weer vanzelf komen. */
      try { if (window.cnCadeau) window.cnCadeau.resetRefusals(); } catch (e) {}
      renderEmptyState();
      return;
    }

    // Altijd full render voor correcte grouping
    renderCartItems(cart);
  };

  const renderCartItems = (cart) => {
    cnNextGiftKeys = new Set();
    if (!cart.items?.length) {
      /* Géén kale <p>-fallback meer: gebruik dezelfde NETTE empty-state
         (kop + subtekst + collectie-grid via cart-empty-template) als
         het reguliere lege-cart-pad, zodat de drawer ook bij de eerste
         render / volledige render de juiste layout toont. */
      cnPrevGiftKeys = cnNextGiftKeys;
      renderEmptyState();
      return;
    }

    // GROEPEER ITEMS VOORDAT WE RENDEREN
    let groupedItems = groupCartItems(cart);

    /* CN Fees: fee-regels (statiegeld) niet als losse rij, maar als
       ADD-ON genest onder hun bijbehorende product (bv. onder de Gold
       Dry). Mapping via window.cnFeeRules (matchProductIds). Fee-regels
       zonder vindbaar moederproduct vallen terug op een eigen (compacte)
       rij — komt in de praktijk alleen voor in de korte periode voordat
       de engine zo'n wees-fee zelf opruimt. */
    const cnFeeAddons = [];
    if (typeof window.cnIsFeeLine === 'function') {
      groupedItems = groupedItems.filter(function (item) {
        if (!window.cnIsFeeLine(item)) return true;
        cnFeeAddons.push(item);
        return false;
      });
    }
    /* Gerenderde rijen mét hun item-data, zodat de fee per rij naar
       rato van het rij-aantal gesplitst kan worden (gift-rij "+ 1 ×",
       betaalde rij "+ 20 ×") — gevuld in de render-loop hieronder. */
    const cnRenderedRows = [];
    const cnAppendAddon = (rowEl, feeQty, fee) => {
      const qtyTxt = feeQty > 1 ? feeQty + '× ' : '';
      const amount = feeQty * (fee.price || 0);   /* fee.price = stukprijs in centen */
      /* Compacte chip NAAST de prijs (op de prijs-regel), i.p.v. een
         volle-breedte balk onder de rij. Korte labelvorm: alles vóór
         "(" uit de producttitel → bv. "Statiegeld", houdt 'm klein. */
      const shortLabel = (fee.product_title || fee.title || 'Statiegeld')
        .split('(')[0].trim() || 'Statiegeld';
      const chip = document.createElement('span');
      chip.className = 'cart-item__fee-chip';
      chip.setAttribute('data-cn-fee-addon', '');
      chip.innerHTML = '+ ' + qtyTxt + shortLabel.replace(/</g, '&lt;')
        + ' <b>' + formatMoney(amount) + '</b>';
      const priceWrap = rowEl.querySelector('.cart-item__price-wrapper');
      (priceWrap || rowEl).appendChild(chip);
    };
    const cnAttachFeeAddons = (rootEl) => {
      if (!cnFeeAddons.length) return;
      const rules = window.cnFeeRules || [];
      cnFeeAddons.forEach(function (fee) {
        const rule = rules.filter(function (r) { return r.feeVariantId === Number(fee.variant_id); })[0];
        /* Alle rijen van producten die deze fee dragen — de fee wordt
           per rij getoond naar rato van het rij-aantal. De som volgt de
           doel-toestand; tijdens een sync-overgang kan het cart-regel-
           aantal heel kort afwijken, de engine trekt dat binnen een
           seconde recht. */
        const matches = rule ? cnRenderedRows.filter(function (rr) {
          return rule.matchProductIds.indexOf(Number(rr.item.product_id)) !== -1
            || rule.matchVariantIds.indexOf(Number(rr.item.variant_id)) !== -1;
        }) : [];
        if (matches.length) {
          matches.forEach(function (rr) {
            const feeQty = (rr.item.quantity || 1) * (rule.qtyPerUnit || 1);
            cnAppendAddon(rr.el, feeQty, fee);
          });
        } else {
          /* Geen moederproduct gevonden → eigen compacte rij (fallback;
             wees-fee wordt door de engine-heartbeat toch opgeruimd). */
          rootEl.appendChild(createCartItemFromTemplate(fee));
        }
      });
    };

    /* IMG-FLASH FIX: snapshot bestaande <img>-elementen per item-key
       vóórdat we de nieuwe DOM bouwen. Bij +/- klikken bouwt de
       template-clone nieuwe <img>-tags met dezelfde src, en zo'n
       splinternieuw img-element triggert een fresh paint (zelfs uit
       cache) → flikkering. We hergebruiken het bestaande element
       door het in de nieuwe DOM in te voegen op de plek van de
       nieuwe template-img — het al-gedecodeerde bitmap blijft
       intact, geen flash. */
    const existingImgs = new Map();
    for (const oldEl of cartItemsRoot.querySelectorAll('.cart-item')) {
      const key = oldEl.dataset.itemKey;
      const img = oldEl.querySelector('.cart-item__image');
      if (key && img) existingImgs.set(key, img);
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'cart-drawer__collection';

    const form = document.createElement('form');
    form.action = `${routes}cart`;
    form.method = 'post';
    form.id = 'CartDrawer-Form';
    form.className = 'cart-drawer__collection-form';

    const frag = document.createDocumentFragment();
    /* Verzamel <img>-elementen die GEEN bestaand DOM-equivalent hebben
       (= nieuwe items, b.v. net aan de cart toegevoegd via PDP of via
       hergebruik die niet matcht qua src/alt). Die moeten we vóór de
       DOM-swap pre-decoden, anders flikkert het beeld als de browser
       pas tijdens of na het inserteren begint met decoderen. Bestaande
       items hergebruiken hun img-element en hoeven dus niet opnieuw
       gedecodeerd te worden. */
    const newImgsToDecode = [];
    for (let i = 0; i < groupedItems.length; i++) {
      const newEl = createCartItemFromTemplate(groupedItems[i]);
      cnRenderedRows.push({ item: groupedItems[i], el: newEl });
      const newImg = newEl.querySelector('.cart-item__image');
      const oldImg = existingImgs.get(newEl.dataset.itemKey);
      if (oldImg && newImg && oldImg.src === newImg.src && oldImg.alt === newImg.alt) {
        newImg.parentNode.replaceChild(oldImg, newImg);
      } else if (newImg && newImg.src) {
        newImgsToDecode.push(newImg);
      }
      frag.appendChild(newEl);
    }
    form.appendChild(frag);
    /* CN Fees: statiegeld als add-on onder het moederproduct hangen. */
    cnAttachFeeAddons(form);
    wrapper.appendChild(form);

    cnPrevGiftKeys = cnNextGiftKeys;
    const swap = () => { cartItemsRoot.replaceChildren(wrapper); cnEnforceGiftsLast(cartItemsRoot); };

    if (newImgsToDecode.length === 0) {
      // Geen nieuwe images → direct swappen (geen flash mogelijk).
      swap();
    } else {
      /* Pre-decode off-DOM met 300ms ceiling. img.decode() kan op
         uncached / grote images 1-2s hangen — dan zou de hele cart
         "vastlopen" op de swap. Race tegen een 300ms timeout: cached
         images halen 't ruimschoots, traag-decodende images krijgen
         een minimale flash maar de cart komt 'm zelf wel snel in
         beeld. Beter klein-beetje flash dan multi-seconden spinner. */
      Promise.race([
        Promise.all(newImgsToDecode.map(img => img.decode().catch(() => {}))),
        new Promise(resolve => setTimeout(resolve, 300)),
      ]).then(swap);
    }
  };

  /* ============================
     Cart-events voor andere onderdelen (cart-page, cadeaubalk, apps)
     ============================ */
  const notifyCartChanged = (cart, source) => {
    if (!cart) return;
    const detail = { cart, source };

    // Standaard cart-events die door theme-widgets en bundle-apps
    // worden afgevangen. cart:updated is bestaand gedrag; de rest
    // is extra "ping" voor apps die andere event-namen kennen.
    const eventNames = [
      'cart:updated',
      'cart:refresh',
      'cart:redrawn',
      'cart:change',
    ];
    // Source-specifieke events.
    if (source === 'add') eventNames.push('cart:item:added');
    if (source === 'change') eventNames.push('cart:item:updated');

    for (const evt of eventNames) {
      try {
        document.dispatchEvent(new CustomEvent(evt, { detail }));
      } catch (e) { /* event-dispatch faalt nooit silent → ignore */ }
    }
  };

  // ============================
  //  CART MUTATIONS
  // ============================
  let updateQueue = Promise.resolve();

  /* Eén +/−-bewerking tegelijk. Mislukt er één (bv. even geen bereik), dan
     vangen we dat hier op: de lade toont weer wat de winkelwagen echt heeft
     en de volgende klik werkt gewoon. Zonder dit bleef de wachtrij hangen
     en deden alle volgende klikken niets meer tot de pagina herladen werd. */
  const resyncAfterFailure = async () => {
    try {
      cartItemsRoot.querySelectorAll('.cart-item--pending').forEach((el) => el.classList.remove('cart-item--pending'));
      lastCartFetchTime = 0;
      const cart = await fetchCart(true);
      if (cart) {
        updateCartUI(cart, null, false, false, { forceFullRender: true });
        updateCartCountInHeader(cart);
      }
    } catch (e) { /* de volgende bewerking probeert het opnieuw */ }
  };
  const enqueueUpdate = (fn) => {
    updateQueue = updateQueue.then(fn).catch((err) => {
      console.error('Cart update failed:', err);
      return resyncAfterFailure();
    });
    return updateQueue;
  };

  /* Debounce per regel-key — zelfde logica als de cart-page.
     Snel achter elkaar +/- klikken wordt samengevoegd tot ÉÉN
     server-call met de laatste waarde. De spinner (processQuantity-
     Update zet het bezig-signaal aan) verschijnt PAS als de
     debounce-timer afloopt → ~0.5s "wachten voor het draait" zodat de
     klant rustig nog een keer kan klikken. Verwijderen (qty 0) is een
     bewuste actie → direct, geen debounce. */
  const cnDrawerQtyTimers = {};
  const cnDrawerQtyLatest = {};
  const CN_DRAWER_QTY_DEBOUNCE_MS = 550;

  /* Het absolute getal dat de klant heeft gekozen, per display-key.
     Zolang een update loopt MOET dit getal blijven staan — geen
     bounce. renderCartItems gebruikt deze waarde i.p.v. de server-qty
     totdat de update volledig is afgehandeld (dan is server == pending
     en valt het naadloos samen). */
  const cnPendingQty = {};

  const updateQuantity = async (key, quantity) => {
    if (+quantity === 0) {
      if (cnDrawerQtyTimers[key]) {
        clearTimeout(cnDrawerQtyTimers[key]);
        delete cnDrawerQtyTimers[key];
        delete cnDrawerQtyLatest[key];
      }
      return enqueueUpdate(() => processQuantityUpdate(key, 0));
    }

    cnDrawerQtyLatest[key] = quantity;
    if (cnDrawerQtyTimers[key]) clearTimeout(cnDrawerQtyTimers[key]);
    cnDrawerQtyTimers[key] = setTimeout(() => {
      const q = cnDrawerQtyLatest[key];
      delete cnDrawerQtyTimers[key];
      delete cnDrawerQtyLatest[key];
      enqueueUpdate(() => processQuantityUpdate(key, q));
    }, CN_DRAWER_QTY_DEBOUNCE_MS);

    return updateQueue;
  };

  /* Checkout-kritiek: dwing elke nog WACHTENDE (gedebouncede, 550ms)
     qty-wijziging nu meteen af en wacht 'm volledig af — incl. de
     removeOrphanedGifts-sweep die processQuantityUpdate intern draait.
     Bewezen race (netwerk-trace): klik snel +/- en meteen daarna op
     checkout → de safeguard zag alleen cnAddInFlight (BOGOS-adds),
     NIET deze debounce-timer. De qty-wijziging landde dan PAS ná de
     checkout-navigatie op de server, terwijl de safeguard's eigen
     cart.js-polls (dezelfde sessie) een "schone" tussentijdse staat
     zagen en 'proceed' gaf — de échte checkout werd gemaakt op een
     cart-snapshot van vóór die late wijziging, met BEIDE gifts op
     volle prijs. Nu: geen wachtende timers meer over vóórdat de
     safeguard ook maar íets controleert. */
  const flushPendingQtyChanges = async () => {
    const keys = Object.keys(cnDrawerQtyTimers);
    keys.forEach((key) => {
      clearTimeout(cnDrawerQtyTimers[key]);
      const q = cnDrawerQtyLatest[key];
      delete cnDrawerQtyTimers[key];
      delete cnDrawerQtyLatest[key];
      enqueueUpdate(() => processQuantityUpdate(key, q));
    });
    try { await updateQueue; } catch (e) { /* een gefaalde update mag de safeguard niet blokkeren */ }
  };

  // Update quantity voor grouped items
  const updateGroupedQuantity = async (groupedKeys, currentTotal, newTotal) => {
    const diff = newTotal - currentTotal;

    if (newTotal <= 0) {
      // Verwijder alle items in de groep
      for (const key of groupedKeys) {
        await fetch(`${routes}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
      }
      lastCartFetchTime = 0;
      return;
    }

    if (diff > 0) {
      // Verhoog: voeg toe aan eerste key
      const cart = await fetchCart(false);
      const firstItem = cart?.items?.find(i => i.key === groupedKeys[0]);
      if (firstItem) {
        await fetch(`${routes}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            id: groupedKeys[0], 
            quantity: firstItem.quantity + diff 
          }),
        });
      }
    } else if (diff < 0) {
      // Verlaag: verwijder vanaf laatste key
      let remaining = Math.abs(diff);
      const cart = await fetchCart(false);
      
      for (let i = groupedKeys.length - 1; i >= 0 && remaining > 0; i--) {
        const item = cart?.items?.find(it => it.key === groupedKeys[i]);
        if (!item) continue;
        
        if (item.quantity <= remaining) {
          await fetch(`${routes}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: groupedKeys[i], quantity: 0 }),
          });
          remaining -= item.quantity;
        } else {
          await fetch(`${routes}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              id: groupedKeys[i], 
              quantity: item.quantity - remaining 
            }),
          });
          remaining = 0;
        }
      }
    }
    // Mutaties uitgevoerd → time-cache van fetchCart invalideren zodat
    // runGroupedUpdate's volgende fetchCart de NIEUWE totalen ophaalt
    // (anders rendert de bundel kort de oude qty terug → flikkering).
    lastCartFetchTime = 0;
  };

  /* Debounce voor grouped/bundle items — zelfde gedrag als de
     per-regel debounce hierboven. Snel achter elkaar +/- klikken op
     een bundel (bv. HEAVY BULK PACK) wordt samengevoegd tot ÉÉN
     server-bewerking met de laatste totaalwaarde. De spinner
     (bezig-signaal) verschijnt PAS als de timer afloopt, zodat
     de klant ~0.5s rustig kan doorklikken zonder dat het direct draait.
     Verwijderen (totaal 0) is een bewuste actie → direct, geen debounce. */
  const cnGroupTimers = {};
  const cnGroupLatest = {};
  const cnGroupKeyId = (groupedKeys) => groupedKeys.join('|');

  const runGroupedUpdate = async (groupedKeys, newTotal) => {
    showCartLoading();
    try {
      let changedCart = null;
      if (groupedKeys.length === 1) {
        /* Eén regel (verreweg het meest): het nieuwe aantal direct zetten.
           Geen /cart.js vooraf nodig, en het antwoord is de hele winkelwagen. */
        const res = await fetch(`${routes}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: groupedKeys[0], quantity: Math.max(0, newTotal) }),
        });
        if (res.ok) changedCart = await res.json().catch(() => null);
      } else {
        // Echte huidige totaal uit server-state — niet uit de
        // optimistisch bijgewerkte input — zodat de diff klopt.
        const preCart = await fetchCart(false);
        let currentTotal = 0;
        for (const k of groupedKeys) {
          const it = preCart?.items?.find(i => i.key === k);
          if (it) currentTotal += it.quantity;
        }
        await updateGroupedQuantity(groupedKeys, currentTotal, newTotal);
      }
      lastCartFetchTime = 0;
      let cart = changedCart ? await adoptCart(changedCart, true) : await fetchCart(true);
      if (cart) {
        /* Ontbrak hier volledig (bug, netwerk-trace-bevestigd): een
           grouped/bundel-qty-wijziging (elke regel wordt als "grouped"
           behandeld, ook een los product) sloeg de orphan-gift-sweep
           over — een gift die door DEZE wijziging onder z'n drempel
           zakt bleef op volle prijs staan totdat een ANDER toevallig
           event (BOGOS' eigen 1200ms-observer, checkout-klik, page-
           reload) de sweep alsnog triggerde. Nu identiek aan
           processQuantityUpdate: direct opruimen. */
        cart = await removeOrphanedGifts(cart);
        cart = await cnEnsureFeesBeforeRender(cart);
        updateCartUI(cart, null, false, false, { forceFullRender: true });
        updateCartCountInHeader(cart);
        /* BELANGRIJK: ook de GROUPED/bundel-quantitywijziging moet de
           cart-PAGINA notificeren (de niet-grouped processQuantityUpdate
           doet dit al). Zonder dit event werd een bundel-+/- in de
           drawer NIET live gesynct met de cart-page. */
        notifyCartChanged(cart, 'change');
      }
    } finally {
      hideCartLoading();
      // Pending pas vrijgeven als er GEEN nieuwere klik in de wacht
      // staat — anders zou een latere render de oude server-qty tonen
      // (bounce). Server == pending op dit punt → naadloos.
      if (!cnGroupTimers[cnGroupKeyId(groupedKeys)]) {
        delete cnPendingQty[groupedKeys[0]];
      }
    }
  };

  const scheduleGroupedUpdate = (groupedKeys, newTotal) => {
    const gid = cnGroupKeyId(groupedKeys);
    if (newTotal <= 0) {
      if (cnGroupTimers[gid]) {
        clearTimeout(cnGroupTimers[gid]);
        delete cnGroupTimers[gid];
        delete cnGroupLatest[gid];
      }
      return enqueueUpdate(() => runGroupedUpdate(groupedKeys, 0));
    }
    cnGroupLatest[gid] = { groupedKeys, newTotal };
    if (cnGroupTimers[gid]) clearTimeout(cnGroupTimers[gid]);
    cnGroupTimers[gid] = setTimeout(() => {
      const payload = cnGroupLatest[gid];
      delete cnGroupTimers[gid];
      delete cnGroupLatest[gid];
      enqueueUpdate(() => runGroupedUpdate(payload.groupedKeys, payload.newTotal));
    }, CN_DRAWER_QTY_DEBOUNCE_MS);
    return updateQueue;
  };

  /* Checkout-kritiek, zelfde reden als flushPendingQtyChanges verderop
     — MAAR voor het GROUPED pad. `groupCartItems` wrapt structureel
     ELKE regel als een "groep" (ook een los product zonder bundel-
     partners), dus in de praktijk loopt de overgrote meerderheid van
     +/- klikken via cnGroupTimers, niet via cnDrawerQtyTimers. Zonder
     deze flush greep de checkout-safeguard's Phase 0 mis: hij leegde
     een lege cnDrawerQtyTimers terwijl de ECHTE wachtende wijziging in
     cnGroupTimers zat — bewezen met een netwerk-trace waarin de
     safeguard 'iter 0 unfree 0' rapporteerde (leek schoon) terwijl de
     up-klik naar qty 9 pas ná die check als change.js-call binnenkwam,
     en de échte checkout alsnog een gift (Gold Dry) op volle prijs
     toonde. */
  const flushPendingGroupChanges = async () => {
    const gids = Object.keys(cnGroupTimers);
    gids.forEach((gid) => {
      clearTimeout(cnGroupTimers[gid]);
      const payload = cnGroupLatest[gid];
      delete cnGroupTimers[gid];
      delete cnGroupLatest[gid];
      if (payload) enqueueUpdate(() => runGroupedUpdate(payload.groupedKeys, payload.newTotal));
    });
    try { await updateQueue; } catch (e) { /* een gefaalde update mag de safeguard niet blokkeren */ }
  };

  const cartHasBundleDiscount = (cart) => {
    if (!cart?.items?.length) return false;
    return cart.items.some(item => 
      item.line_level_discount_allocations?.some(alloc => 
        alloc.discount_application?.title
      )
    );
  };

  const pollForDiscounts = async (maxAttempts = 4, delayMs = 500) => {
    /* GEEN eigen spinner meer: deze poll draait
       alleen binnen processQuantityUpdate, waar de grote loading-overlay
       al actief is — de tweede gecentreerde spinner stapelde daar
       zichtbaar overheen (sinds de gift-kortingscodes line-level
       discounts zetten triggert de bundle-branch ook bij gift-removals). */
    try {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        if (attempt > 0) {
          await new Promise(resolve => setTimeout(resolve, delayMs));
        }
        
        const cart = await fetchCart(false);
        if (!cart) continue;
        
        if (cartHasBundleDiscount(cart)) {
          return await enrichCartItems(cart);
        }
      }
      
      const cart = await fetchCart(true);
      return cart;
    } finally {
      /* discountLoader-toggle bewust verwijderd — zie boven. */
    }
  };

  /* Cadeaus in orde brengen voor deze cart (snippets/cn-cadeau.liquid):
     cadeau erbij zodra de drempel gehaald is, weg als je eronder zakt,
     oude BOGOS-cadeauregels weg. Geeft de (verse, verrijkte) cart terug.
     De naam is gebleven omdat de cart-page hem ook gebruikt
     (window.cnRemoveOrphanedGifts). */
  const removeOrphanedGifts = async (cart) => {
    if (!cart || !window.cnCadeau) return cart;
    return window.cnCadeau.reconcile(cart, {
      fetchCart: () => { lastCartFetchTime = 0; return fetchCart(true); },
    });
  };

  const processQuantityUpdate = async (key, quantity) => {
    showCartLoading();
    const isRemoval = quantity === 0;

    try {
      let hadBundleDiscount = false;
      let remainingBundleItems = 0;

      if (isRemoval) {
        /* Verse cart (time-cache invalideren): een net toegevoegd cadeau
           zit nog niet in de gecachte snapshot. */
        lastCartFetchTime = 0;
        const currentCart = await fetchCart(false);
        if (currentCart?.items) {
          hadBundleDiscount = cartHasBundleDiscount(currentCart);

          if (hadBundleDiscount) {
            remainingBundleItems = currentCart.items.filter(item =>
              item.key !== key &&
              item.line_level_discount_allocations?.some(alloc =>
                alloc.discount_application?.title
              )
            ).length;
          }

          /* Gooit de klant een cadeau weg, dan onthoudt de cadeaumotor dat
             en zet hij het niet vanzelf terug. */
          const removingItem = currentCart.items.find(i => i.key === key);
          if (removingItem && window.cnCadeau) window.cnCadeau.noteRemoval(removingItem);
        }
      }

      const res = await fetch(`${routes}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const changedCart = await res.json().catch(() => null);
      // Cart is net server-side gewijzigd → de 300ms time-cache van
      // fetchCart bevat nog de OUDE hoeveelheid. Invalideren zodat de
      // volgende fetchCart gegarandeerd verse data ophaalt (anders
      // rendert de UI kort de oude qty → "2→1→2→1" flikkering).
      lastCartFetchTime = 0;

      let cart;

      if (isRemoval && hadBundleDiscount && remainingBundleItems > 0) {
        cart = await pollForDiscounts();
      } else {
        /* Het antwoord van change.js is de nieuwe winkelwagen. */
        cart = await adoptCart(changedCart, true);
      }
      
      if (!cart) throw new Error('fetchCart returned null');

      // Cadeaus bijwerken: een lager bedrag kan een cadeau kosten, een hoger bedrag er een opleveren.
      cart = await removeOrphanedGifts(cart);
      cart = await cnEnsureFeesBeforeRender(cart);

      updateCartUI(cart, null, false, false, { forceFullRender: true });
      updateCartCountInHeader(cart);
      notifyCartChanged(cart, 'change');
    } catch (err) {
      console.error('Error updating cart:', err);
      const cart = await fetchCart(true);
      if (cart) {
        const cleanedCart = await removeOrphanedGifts(cart);
        updateCartUI(cleanedCart, null, false, false, { forceFullRender: true });
        updateCartCountInHeader(cleanedCart);
      }
    } finally {
      hideCartLoading();
      // Pending alleen vrijgeven als er geen nieuwere klik wacht.
      if (!cnDrawerQtyTimers[key]) {
        delete cnPendingQty[key];
      }
    }
  };

  // ============================
  //  OPEN / CLOSE
  // ============================
  const closeProductOverlays = () => {
    let closedAny = false;
    document
      .querySelectorAll('#Quick-view, product-information-drawer, .product-information-drawer')
      .forEach((drawer) => {
        try {
          if (drawer.isOpen || drawer.classList.contains('is-opened')) {
            if (typeof drawer.hide === 'function') drawer.hide();
            else if (typeof drawer.toggle === 'function' && drawer.isOpen) drawer.toggle();
            closedAny = true;
          }
        } catch {}
      });
    return closedAny;
  };

  /* Background scroll-lock terwijl de drawer open is. overflow:hidden
     op <html> + padding-right ter compensatie van de verdwijnende
     scrollbar zodat de pagina niet zijwaarts verspringt. Zelfde
     aanpak als de quick-view lock. */
  /**
   * Background scroll-lock via position:fixed body pattern.
   *
   * Waarom niet meer `overflow: hidden`: dat veranderde de scrolling-
   * ancestor van position:sticky elementen (PDP product-images, header
   * sticky balk). Sticky-elementen verloren hun "vastzitten" en
   * sprongen omhoog/zijwaarts zodra de drawer opende.
   *
   * Hier: snapshot scrollY, freeze body via position:fixed + top:-Y.
   * Page blijft visueel op zelfde plek; sticky-context (html) blijft
   * unchanged → geen verticale shift van product images of header.
   * Padding-right op body + fixed-header elementen vangt de
   * scrollbar-breedte op → geen horizontale shift.
   */
  let cnSavedScrollY = 0;
  const cnLockBackgroundScroll = () => {
    cnSavedScrollY = window.scrollY || window.pageYOffset || 0;

    // Width: match html.clientWidth (= viewport - scrollbar-gutter) zodat
    // de fixed body exact dezelfde breedte heeft als z'n normale state.
    // Met `scrollbar-gutter: stable` reserveert html een gutter; een
    // naive `width: 100%` op position:fixed body pakt de volle viewport
    // (incl. gutter) → body wordt ~15px breder → header items shiften
    // naar rechts. Pinned width voorkomt dat.
    const lockedWidth = document.documentElement.clientWidth;
    const b = document.body.style;
    b.position = 'fixed';
    b.top = '-' + cnSavedScrollY + 'px';
    b.left = '0';
    b.width = lockedWidth + 'px';

    document.documentElement.classList.add('cn-cart-drawer-locked');
  };
  const cnUnlockBackgroundScroll = () => {
    const b = document.body.style;
    b.position = '';
    b.top = '';
    b.left = '';
    b.width = '';
    document.documentElement.classList.remove('cn-cart-drawer-locked');
    window.scrollTo(0, cnSavedScrollY);
  };

  /**
   * Reviews.io carousel widget is op idle al gemount in de (verborgen)
   * drawer. Zonder layout-calc bij init blijft de carousel intern op
   * 0×0 staan. Wanneer de drawer zichtbaar wordt: kick 'm met een
   * window resize-event — Reviews.io's interne ResizeObserver pakt
   * dat op en herberekent de slide-breedtes + scroll-positie.
   */
  const wakeReviewWidget = () => {
    try {
      window.dispatchEvent(new Event('resize'));
    } catch (e) { /* silent */ }
  };

  const openCartWithoutFetch = () => {
    closeProductOverlays();
    cartBackdrop.style.display = 'block';
    cartDrawer.style.display = 'flex';
    /* Drawer opent → altijd bovenaan beginnen (progress-widget +
       bovenste items in beeld), ongeacht waar de vorige sessie/scroll
       stond. Geldt ook voor de add-to-cart flow die de drawer opent. */
    cartDrawer.scrollTop = 0;
    /* Vangnet: corrigeer een evt. stale volgorde (statische server-paint
       met een gift die toen nog vol-prijs was) meteen bij het openen,
       vóór de drawer in beeld schuift — geen zichtbare sprong. */
    try { cnEnforceGiftsLast(); } catch (e) {}
    cnLockBackgroundScroll();
    requestAnimationFrame(() => {
      cartBackdrop.classList.add('open');
      cartDrawer.classList.add('open');
      // Na display:flex + open-class: het widget kan nu zijn layout
      // doen. Eén RAF later (browser heeft layout berekend) → resize.
      requestAnimationFrame(wakeReviewWidget);
    });
  };

  /* Bezig-signaal in de lade. Vroeger lag hier een grijze laag met een
     draaiend rondje over de hele lade die alle klikken blokkeerde (nodig
     toen BOGOS op zijn eigen moment dingen deed). De lade voert wijzigingen
     nu één voor één uit (updateQueue) en de cadeaumotor ook, dus klikken mag
     gewoon. Nu: een dun goudlijntje onder de kop en een iets lichter totaal
     (klasse is-syncing op #cart-custom), en de gewijzigde regel iets lichter
     (cart-item--pending, gezet bij de klik). Afrekenen blijft veilig: de
     safeguard maakt wachtende wijzigingen eerst af.
     showCartLoading/hideCartLoading en awaitDrawerOpenThenShowLoading houden
     hun naam, zodat alle bestaande aanroepen blijven werken. */
  let cnSyncCount = 0;
  let cnSyncShowTimer = null;
  let cnSyncSafety = null;
  const cnSyncStart = (delay) => {
    cnSyncCount++;
    clearTimeout(cnSyncShowTimer);
    cnSyncShowTimer = setTimeout(() => {
      if (cnSyncCount > 0) cartDrawer?.classList.add('is-syncing');
    }, typeof delay === 'number' ? delay : 200);
    /* Vangnet: blijft het signaal door een vastgelopen verzoek staan, dan
       na 12 s weg (het blokkeert niets, maar het hoort niet te blijven). */
    clearTimeout(cnSyncSafety);
    cnSyncSafety = setTimeout(() => { cnSyncCount = 0; cartDrawer?.classList.remove('is-syncing'); }, 12000);
  };
  const cnSyncEnd = () => {
    cnSyncCount = Math.max(0, cnSyncCount - 1);
    if (cnSyncCount > 0) return;
    clearTimeout(cnSyncShowTimer);
    clearTimeout(cnSyncSafety);
    cartDrawer?.classList.remove('is-syncing');
  };
  /* Openen en toevoegen: signaal meteen aan, finish() zet het uit. */
  const awaitDrawerOpenThenShowLoading = () => {
    cnSyncStart(0);
    let done = false;
    return () => { if (!done) { done = true; cnSyncEnd(); } };
  };
  function showCartLoading(delay) { cnSyncStart(delay); }
  function hideCartLoading() { cnSyncEnd(); }

  const openCart = async () => {
    closeProductOverlays();
    cartBackdrop.style.display = 'block';
    cartDrawer.style.display = 'flex';
    /* Altijd bovenaan beginnen bij openen — zie openCartWithoutFetch. */
    cartDrawer.scrollTop = 0;
    /* Vangnet: stale volgorde meteen corrigeren vóór de fetch-render,
       zodat de static paint niet even met een gift-in-het-midden flitst. */
    try { cnEnforceGiftsLast(); } catch (e) {}
    cnLockBackgroundScroll();
    requestAnimationFrame(() => {
      cartBackdrop.classList.add('open');
      cartDrawer.classList.add('open');
      // Trigger Reviews.io re-layout zodra drawer zichtbaar is.
      requestAnimationFrame(wakeReviewWidget);
    });

    const finishLoading = awaitDrawerOpenThenShowLoading();

    try {
      const cart = await fetchCart(true);
      if (cart) {
        /* Eén render: updateCartUI rendert zelf al (renderCartItems
           erbovenop was een dubbele rebuild → zichtbare flikker). */
        updateCartUI(cart);
        updateCartCountInHeader(cart);
        notifyCartChanged(cart, 'open');
      }
    } catch (err) {
      console.error('Failed to refresh cart on open:', err);
    } finally {
      finishLoading();
    }
  };

  const closeCart = () => {
    /* Cancel een lopende checkout-safeguard zodat z'n fetches/wait-loops
       niet doortikken nadat de klant de drawer weglegt. Zonder dit blijft
       de safeguard 10-12s lang requests pollen ook al kijkt niemand er
       meer naar — verspilling van bandwidth/battery. */
    if (cnActiveCheckoutAbort && !cnActiveCheckoutAbort.signal.aborted) {
      try { cnActiveCheckoutAbort.abort(); } catch (e) {}
    }
    cartBackdrop.classList.remove('open');
    cartDrawer.classList.remove('open');
    /* Reset fully-open flag → volgende openen wacht weer netjes op
       de slide-in transitionend vóór de overlay verschijnt. */
    delete cartDrawer.dataset.cnFullyOpen;
    /* Scroll DIRECT unlocken zodat het 15px padding-right-strip
       (body lock-state) niet zichtbaar blijft terwijl de drawer
       wegschuift. De drawer is position:fixed dus body-state
       beïnvloedt de slide-animatie niet. scrollTo is synchroon
       → één paint zonder shift. */
    cnUnlockBackgroundScroll();
    /* Display:none na de close-transition (520ms CSS + 40ms buffer)
       zodat de drawer-DOM niet ineens uit z'n animatie geknipt wordt. */
    setTimeout(() => {
      cartBackdrop.style.display = 'none';
      cartDrawer.style.display = 'none';
    }, 560);
  };

  // ============================
  //  EVENTS (UI)
  // ============================
  closeBtn.addEventListener('click', closeCart);
  cartBackdrop.addEventListener('click', closeCart);

  /* ──────────────────────────────────────────────────────────────
     CHECKOUT-CONTROLE
     ──────────────────────────────────────────────────────────────
     Vlak vóór de kassa: wachtende aantal-wijzigingen afmaken, cadeaus
     bijwerken (cadeaumotor) en een cadeauregel die toch niet gratis is
     weghalen. De korting op het cadeau zit meteen in de prijs (Shopify
     Function "Cadeau korting" in de CN Bundle App), dus er valt niets
     af te wachten. Daarna gaat de klant met een directe navigatie naar
     /checkout (geen form-submit; de order-note persisten we zelf). */
  const safeguardLog = (...args) => {
    if (window.cnDebugSafeguard !== true) return;
    try { console.log('[cnSafeguard]', ...args); } catch (e) {}
  };

  /* Cadeauregels die (nog) niet gratis zijn, ook oude BOGOS-cadeaus. */
  const detectUnfreeGifts = (cart) => {
    if (!cart || !cart.items) return [];
    return cart.items.filter((item) => {
      const hasNonZeroPrice = (item.final_price > 0) || (item.final_line_price > 0);
      const giftish = window.cnCadeau ? window.cnCadeau.isGiftLine(item) : isGiftLine(item);
      return hasNonZeroPrice && giftish;
    });
  };

  /* Eén verse cart-fetch met AbortSignal. null bij netwerk-/serverfout,
     gooit AbortError bij afbreken. */
  const safeguardFetchCart = async (signal) => {
    try {
      const res = await fetch(`${routes}cart.js`, {
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal,
      });
      if (!res.ok) return null;
      return await res.json();
    } catch (err) {
      if (err && err.name === 'AbortError') throw err;
      return null;
    }
  };

  /* Niet-gratis cadeauregels weghalen en de lade opnieuw tekenen. */
  const stripUnfreeGifts = async (gifts, signal) => {
    const updates = {};
    gifts.forEach((item) => { updates[item.key] = 0; });
    try {
      await fetch(`${routes}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
        signal,
      });
    } catch (e) { /* netwerk of afgebroken: volgende render herstelt */ }
    lastCartFetchTime = 0;
    let cleaned = null;
    try { cleaned = await safeguardFetchCart(signal); } catch (e) { /* afgebroken */ }
    if (cleaned) {
      updateCartUI(cleaned, null, false, false, { forceFullRender: true });
      updateCartCountInHeader(cleaned);
      notifyCartChanged(cleaned, 'gift-safeguard');
    }
    return cleaned;
  };

  /* Order-note persisten vóór directe navigatie. De note bereikte
     cart.note voorheen uitsluitend via de form-POST; bij een harde nav
     moet 'ie expliciet. Falen is non-blocking — de note is nice-to-have,
     de checkout nooit blokkeren. */
  window.cnPersistCartNote = async function () {
    try {
      const ta = document.getElementById('CartPageNote')
        || document.querySelector('[data-cart-note-textarea]');
      if (!ta) return; /* drawer/andere pagina — geen note-veld */
      /* defaultValue kan stale zijn na cnRenderCartSafe-morphs; bij
         twijfel posten — één idempotente request is de veilige default.
         Alleen skippen als er aantoonbaar niets te syncen valt. */
      if (ta.value === '' && ta.defaultValue === '') return;
      const ctrl = new AbortController();
      const t = setTimeout(() => { try { ctrl.abort(); } catch (e) {} }, 1500);
      /* `_cn_fees=1`: cn-fees' fetch-wrap geen sync laten plannen. */
      await fetch(`${routes}cart/update.js?_cn_fees=1`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: ta.value }),
        signal: ctrl.signal,
      });
      clearTimeout(t);
    } catch (e) { /* note-sync mislukt — doorgaan, nooit hangen */ }
  };

  /* Checkout-watchdog: strandt de navigatie (offline, traag netwerk),
     dan mag de klant niet met een dode disabled-knop + eeuwige spinner
     achterblijven. Na `ms` (default 5s) nog steeds op de pagina →
     alle checkout-knoppen en guard-flags resetten zodat een retry-klik
     gewoon werkt (safeguard is idempotent). Cancel op pagehide — NIET
     beforeunload, dat vuurt al bij het toewijzen van location.href,
     vóór de navigatie daadwerkelijk commit. */
  const cnCheckoutUISweep = function () {
    try {
      document.querySelectorAll(
        '#checkout, [data-cart-page-checkout-button], .cn-sticky-checkout__btn, #cart-custom-checkout'
      ).forEach(function (btn) {
        try {
          btn.removeAttribute('disabled');
          btn.classList.remove('cn-checkout-waiting');
          btn.setAttribute('aria-busy', 'false');
          if (btn.dataset) delete btn.dataset.cnCheckoutGuard;
        } catch (e) {}
      });
      const f = document.getElementById('CartPageForm');
      if (f && f.dataset) delete f.dataset.cnSafeguardPassed;
      /* Niet (meer) aan het navigeren → cart-page mag weer refreshen. */
      window.__cnCheckoutInProgress = false;
    } catch (e) {}
  };
  let cnWatchdogTimer = null;
  let cnWatchdogCancel = null;
  /* De restore van de laatste vertrekpoging. De watchdog stopt bij pagehide,
     dus komt de pagina terug uit de bfcache (terugknop vanuit de kassa), dan
     zet de pageshow-handler hieronder knop en vlaggen met deze restore terug. */
  let cnWatchdogRestore = null;
  window.cnArmCheckoutWatchdog = function (restore, ms) {
    try {
      if (cnWatchdogTimer) clearTimeout(cnWatchdogTimer);
      if (cnWatchdogCancel) window.removeEventListener('pagehide', cnWatchdogCancel);
      cnWatchdogRestore = typeof restore === 'function' ? restore : null;
      cnWatchdogCancel = function () {
        if (cnWatchdogTimer) clearTimeout(cnWatchdogTimer);
        cnWatchdogTimer = null;
      };
      window.addEventListener('pagehide', cnWatchdogCancel, { once: true });
      cnWatchdogTimer = setTimeout(function () {
        cnWatchdogTimer = null;
        window.removeEventListener('pagehide', cnWatchdogCancel);
        /* Tab op achtergrond midden in de nav — niet tegenwerken. */
        if (document.visibilityState === 'hidden') return;
        cnCheckoutUISweep();
        cnWatchdogRestore = null;
        if (typeof restore === 'function') { try { restore(); } catch (e) {} }
      }, ms || 5000);
    } catch (e) {}
  };

  /* Het centrale directe checkout-pad — vervangt form.requestSubmit op
     alle entry-points (cart-page, sticky, drawer). Trage-maar-gelukte
     navigatie waarbij de watchdog de knop kort her-enablet is bewust
     acceptabel: een retry-klik draait de idempotente safeguard opnieuw. */
  window.cnGoDirectCheckout = async function (opts) {
    opts = opts || {};
    /* Vóór al het async werk: bevriest de swap/refresh-paden van de
       cart-page tijdens het vertrek (navigation-intercept + refresh). */
    window.__cnCheckoutInProgress = true;
    window.__cnCheckoutInProgressAt = Date.now();
    /* Tripwire: draait de MMF-app-embed tóch nog, dan slaapt de CN
       Fees-engine en rekent MMF fees alleen bij form-submit — directe
       nav zou dan statiegeld kunnen missen. Hoort uit te staan. */
    try {
      if (document.querySelector('magical-mandatory-fees')) {
        console.warn('[CN] MMF-embed actief — directe nav kan statiegeld missen');
      }
    } catch (e) {}
    try { await window.cnPersistCartNote(); } catch (e) {}
    window.cnArmCheckoutWatchdog(opts.restore, opts.watchdogMs);
    window.location.href = `${routes}checkout`;
  };

  /* FAILSAFE voor kale navigatie-paden — het invariant afdwingen vlak vóór
     een harde nav naar /checkout. Gebruikt door de catch-redirects
     (drawer + cart-page): die navigeerden voorheen BLIND, waardoor een
     gift die net (op volle prijs) was bijgekomen alsnog door de checkout
     kon. Nu eerst een verse cart-check + strip, dan pas navigeren.
     Nooit de navigatie blokkeren op een fout — "nooit laten hangen" wint. */
  window.cnEnsureNoUnfreeThenGo = async function (url) {
    try {
      const cart = await safeguardFetchCart(null);
      if (cart) {
        const unfree = detectUnfreeGifts(cart);
        if (unfree.length) await stripUnfreeGifts(unfree, null);
      }
    } catch (e) { /* bij twijfel toch doorgaan — niet hangen */ }
    window.__cnCheckoutInProgress = true;
    window.__cnCheckoutInProgressAt = Date.now();
    window.cnArmCheckoutWatchdog();
    window.location.href = url;
  };

  window.cnCheckoutSafeguard = async function (opts) {
    opts = opts || {};
    const signal = opts.signal || null;
    const isAborted = () => signal && signal.aborted;

    try {
      /* Nog wachtende (gedebouncede) aantal-wijzigingen eerst afmaken:
         lade per regel, lade per groep en de cart-page. Anders gaat de
         kassa uit van een stand die de server een tel later overschrijft. */
      await flushPendingQtyChanges();
      await flushPendingGroupChanges();
      if (typeof window.cnFlushCartPageQty === 'function') {
        try { await window.cnFlushCartPageQty(); } catch (e) { /* best-effort */ }
      }
      if (isAborted()) return 'aborted';

      let cart = await safeguardFetchCart(signal);
      if (!cart) {
        await new Promise((r) => setTimeout(r, 500));
        if (isAborted()) return 'aborted';
        cart = await safeguardFetchCart(signal);
        /* Twee keer mislukt: netwerk echt stuk. Niet blind doorgaan. */
        if (!cart) return 'network-error';
      }

      /* Cadeaus bijwerken (erbij of eraf) en één eindcontrole. */
      cart = (await removeOrphanedGifts(cart)) || cart;
      if (isAborted()) return 'aborted';
      const unfree = detectUnfreeGifts(cart);
      if (unfree.length) {
        safeguardLog('cadeau niet gratis, weghalen', unfree.length);
        cart = (await stripUnfreeGifts(unfree, signal)) || cart;
      }

      /* Statiegeld: laatste ensure (doorgaans geen netwerk). */
      try {
        if (typeof window.cnFeesEnsure === 'function') await window.cnFeesEnsure(cart);
      } catch (e) { /* nooit de kassa blokkeren */ }
      return 'proceed';
    } catch (err) {
      if (err && err.name === 'AbortError') return 'aborted';
      safeguardLog('onverwachte fout', err);
      return 'network-error';
    }
  };

  /* Houdt de actieve checkout-AbortController bij zodat closeCart 'm kan
     cancelen. Per moment slechts ÉÉN actief (cnCheckoutGuard='busy'
     voorkomt parallelle clicks). */
  let cnActiveCheckoutAbort = null;

  /* Naar de checkout via DIRECTE navigatie (cnGoDirectCheckout). Ging
     voorheen via een verse-form-submit met [name="checkout"] — dat is
     verlaten: BOGOS kaapt zulke submits (progressEventCheckout → POST
     /cart?sca_checkout_form= → 422 zonder fallback → dode knop), en de
     oude MMF-fees-rationale is achterhaald sinds de CN Fees-engine het
     statiegeld als échte cart-regel borgt (cnFeesEnsure draait in
     cnCheckoutSafeguard vóór 'proceed'). Historie: zie git log. */
  const cnSubmitCheckoutForm = () => {
    window.cnGoDirectCheckout();
  };

  checkoutBtn.addEventListener('click', async () => {
    const goShop = checkoutBtn.dataset.cta === 'shop';
    if (goShop) {
      window.location.href = `${routes}collections/alle-producten`;
      return;
    }
    if (checkoutBtn.dataset.cnCheckoutGuard === 'busy') return;
    checkoutBtn.dataset.cnCheckoutGuard = 'busy';

    const origLabel = checkoutLabel ? checkoutLabel.textContent : '';
    const setLabel = (text) => { if (checkoutLabel) checkoutLabel.textContent = text; };
    const setWaiting = (on) => {
      checkoutBtn.classList.toggle('cn-checkout-waiting', !!on);
      checkoutBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    };
    const releaseGuard = () => {
      delete checkoutBtn.dataset.cnCheckoutGuard;
      setLabel(origLabel);
      setWaiting(false);
    };

    const controller = new AbortController();
    cnActiveCheckoutAbort = controller;

    try {
      const result = await window.cnCheckoutSafeguard({
        signal: controller.signal,
        onWait: () => {
          setWaiting(true);
          setLabel(CHECKOUT_WAIT_LABEL);
        },
      });

      if (result === 'proceed') {
        delete checkoutBtn.dataset.cnCheckoutGuard;
        cnSubmitCheckoutForm();
        return;
      }
      if (result === 'gift-removed') {
        /* Failsafe: de gift is weggehaald (kon niet gratis). NOOIT laten
           hangen → kort de melding tonen en dan gewoon door naar checkout.
           De cart is op dit punt gegarandeerd vrij van volle-prijs gifts. */
        setWaiting(false);
        setLabel(CHECKOUT_GIFT_REMOVED_LABEL);
        delete checkoutBtn.dataset.cnCheckoutGuard;
        setTimeout(cnSubmitCheckoutForm, 1200);
        return;
      }
      if (result === 'timeout') {
        setLabel(CHECKOUT_TIMEOUT_LABEL);
        setWaiting(false);
        setTimeout(releaseGuard, 3000);
        return;
      }
      if (result === 'network-error') {
        setLabel(CHECKOUT_NETWORK_ERROR_LABEL);
        setWaiting(false);
        setTimeout(releaseGuard, 3000);
        return;
      }
      /* 'aborted' — drawer dicht, geen UI-update nodig. Reset wel zodat
         bij heropening de knop niet "busy" blijft. */
      releaseGuard();
    } catch (err) {
      releaseGuard();
    } finally {
      if (cnActiveCheckoutAbort === controller) cnActiveCheckoutAbort = null;
    }
  });

  document.addEventListener(
    'click',
    (e) => {
      const cartToggler = e.target.closest('#CartDrawerToggler, [data-sidebar-id="CartDrawer"]');
      if (cartToggler) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openCart();
      }
    },
    true
  );

  // UPDATED: Event handlers voor grouped items
  cartItemsContainer.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      e.preventDefault();
      const itemEl = removeBtn.closest('.cart-item');
      /* Meteen zichtbaar dat deze regel weggaat (bezig-signaal). */
      itemEl?.classList.add('cart-item--pending', 'cart-item--leaving');
      const isGrouped = itemEl?.dataset.isGrouped === 'true';
      
      if (isGrouped) {
        const groupedKeys = JSON.parse(itemEl.dataset.groupedKeys || '[]');
        showCartLoading();
        /* try/finally: elke throw tussen de awaits (mislukte fetch e.d.)
           liet de overlay anders permanent staan — en die blokkeert
           sinds kort ook alle clicks → complete lockup. */
        try {

        /* Gooit de klant een cadeau weg, dan onthoudt de cadeaumotor dat
           en zet hij het niet vanzelf terug (zelfde als processQuantityUpdate). */
        try {
          lastCartFetchTime = 0;
          const preCart = await fetchCart(false);
          for (const key of groupedKeys) {
            const it = preCart?.items?.find(i => i.key === key);
            if (it && window.cnCadeau) window.cnCadeau.noteRemoval(it);
          }
        } catch (e) { /* niet-blokkerend voor de remove zelf */ }

        // Verwijder alle items in de groep.
        for (const key of groupedKeys) {
          await fetch(`${routes}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
        }

        lastCartFetchTime = 0;
        let cart = await fetchCart(true);
        if (cart) {
          cart = await removeOrphanedGifts(cart);
          cart = await cnEnsureFeesBeforeRender(cart);
          updateCartUI(cart, null, false, false, { forceFullRender: true });
          updateCartCountInHeader(cart);
        }
        } finally {
          hideCartLoading();
        }
      } else {
        updateQuantity(removeBtn.dataset.removeItem, 0);
      }
      return;
    }

    const minusBtn = e.target.closest('[data-quantity-minus]');
    if (minusBtn && !minusBtn.disabled) {
      e.preventDefault();
      const itemEl = minusBtn.closest('.cart-item');
      itemEl?.classList.add('cart-item--pending');
      const isGrouped = itemEl?.dataset.isGrouped === 'true';
      
      if (isGrouped) {
        const groupedKeys = JSON.parse(itemEl.dataset.groupedKeys || '[]');
        const input = itemEl.querySelector('[data-quantity-input]');
        const currentQty = parseInt(input.value, 10);
        const newQty = Math.max(0, currentQty - 1);
        // Optimistisch de zichtbare waarde bijwerken zodat snel
        // achter-elkaar klikken correct aftrekt tijdens de debounce.
        if (input) input.value = newQty;
        cnPendingQty[groupedKeys[0]] = newQty;
        scheduleGroupedUpdate(groupedKeys, newQty);
      } else {
        const key = minusBtn.dataset.quantityMinus;
        const input = document.querySelector(`[data-quantity-input="${key}"]`);
        const newQty = Math.max(1, parseInt(input.value, 10) - 1);
        // Optimistisch de zichtbare waarde bijwerken zodat snel
        // achter-elkaar klikken correct aftrekt tijdens de debounce.
        if (input) input.value = newQty;
        cnPendingQty[key] = newQty;
        updateQuantity(key, newQty);
      }
      return;
    }

    const plusBtn = e.target.closest('[data-quantity-plus]');
    if (plusBtn) {
      e.preventDefault();
      const itemEl = plusBtn.closest('.cart-item');
      itemEl?.classList.add('cart-item--pending');
      const isGrouped = itemEl?.dataset.isGrouped === 'true';
      
      if (isGrouped) {
        const groupedKeys = JSON.parse(itemEl.dataset.groupedKeys || '[]');
        const input = itemEl.querySelector('[data-quantity-input]');
        const currentQty = parseInt(input.value, 10);
        const newQty = currentQty + 1;
        // Optimistisch de zichtbare waarde bijwerken zodat snel
        // achter-elkaar klikken correct optelt tijdens de debounce.
        if (input) input.value = newQty;
        cnPendingQty[groupedKeys[0]] = newQty;
        scheduleGroupedUpdate(groupedKeys, newQty);
      } else {
        const key = plusBtn.dataset.quantityPlus;
        const input = document.querySelector(`[data-quantity-input="${key}"]`);
        const newQty = parseInt(input.value, 10) + 1;
        // Optimistisch de zichtbare waarde bijwerken zodat snel
        // achter-elkaar klikken correct optelt tijdens de debounce.
        if (input) input.value = newQty;
        cnPendingQty[key] = newQty;
        updateQuantity(key, newQty);
      }
      return;
    }
  });

  cartItemsContainer.addEventListener('change', async (e) => {
    const qtyInput = e.target.closest('[data-quantity-input]');
    if (qtyInput) {
      const itemEl = qtyInput.closest('.cart-item');
      itemEl?.classList.add('cart-item--pending');
      const isGrouped = itemEl?.dataset.isGrouped === 'true';
      const newQty = parseInt(qtyInput.value, 10) || 0;
      
      if (isGrouped) {
        const groupedKeys = JSON.parse(itemEl.dataset.groupedKeys || '[]');
        cnPendingQty[groupedKeys[0]] = newQty;
        scheduleGroupedUpdate(groupedKeys, newQty);
      } else {
        const key = qtyInput.dataset.quantityInput;
        cnPendingQty[key] = newQty;
        updateQuantity(key, newQty);
      }
    }
  });

  // ============================
  //  ADD-TO-CART INTERCEPTOR
  // ============================
  let addQueue = window.__cartLiteQueue;

  const onAddToCartCapture = (e) => {
    const form = e.target;
    if (!form || form.dataset.type !== 'add-to-cart-form') return;
    if (form.hasAttribute('data-cart-lite-optout')) return;
    if (form.dataset.busy === 'true') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    form.dataset.busy = 'true';
    const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
    if (submitBtn) submitBtn.disabled = true;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    /* Smoother ATC-flow bij quick-view / product-info-drawer:
       eerst de overlay netjes laten sluiten (animatie ~260ms), DAN
       pas de cart drawer openen. Voorheen sloegen beide animaties
       tegelijk af — vooral op mobile (waar beide drawers full-width
       zijn) voelde dat schokkerig. Was er geen overlay open dan
       direct openen, anders na de close-animatie. */
    const hadOverlay = closeProductOverlays();
    const openCartDrawer = () => openCartWithoutFetch();
    if (hadOverlay) {
      setTimeout(openCartDrawer, 260);
    } else {
      openCartDrawer();
    }

    /* Coördineer overlay-timing met drawer-open animatie zodat de
       spinner niet vóór de zichtbare drawer verschijnt. Helper
       retourneert een finish() die we in finally aanroepen. */
    const finishLoading = awaitDrawerOpenThenShowLoading();

    addQueue = addQueue.then(async () => {
      try {
        const formData = new FormData(form);
        /* `keepalive: true` zorgt dat de browser de cart/add.js
           request niet afbreekt als de gebruiker tussen klik en
           response op een interne link klikt (b.v. snel door de
           collectie scrollen + tikken op "in winkelwagen" + meteen
           door naar een ander product). Zonder keepalive werd de
           in-flight fetch gecancel'd op de paginanav → product
           belandde nooit in de cart. Body-limit is 64 KiB → ruim
           genoeg voor cart-form data. */
        const addRes = await fetch(`${routes}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: XHR_HDRS,
          keepalive: true,
        });

        if (!addRes.ok) {
          const errorData = await addRes.json().catch(() => null);
          const addErr = new Error(errorData?.description || errorData?.message || `HTTP ${addRes.status}`);
          /* Shopify geeft een vertaalde uitleg terug ("is al uitverkocht",
             "je kunt er maar 3 toevoegen"). Die tonen we in de lade. */
          addErr.cnShopMessage = (errorData && typeof errorData.description === 'string' && errorData.description)
            || (errorData && typeof errorData.message === 'string' && errorData.message)
            || '';
          throw addErr;
        }

        await addRes.text();

        let cart = await fetchCart(true);
        if (!cart) throw new Error('fetchCart returned null');

        /* Cadeau meteen mee in dezelfde render als het product: haalt
           deze toevoeging de drempel, dan legt de cadeaumotor het
           cadeau erbij (en Shopify maakt het direct €0). */
        cart = await removeOrphanedGifts(cart);
        /* Statiegeld direct mee in dezelfde render als het product —
           de add-overlay draait toch al; dit voorkomt het "product
           eerst, statiegeld 1s later"-effect. */
        cart = await cnEnsureFeesBeforeRender(cart);

        hideAddNotice();
        updateCartUI(cart);
        updateCartCountInHeader(cart);
        notifyCartChanged(cart, 'add');
      } catch (err) {
        console.error('Add to cart failed:', err);
        const cart = await fetchCart();
        if (cart) {
          updateCartUI(cart);
          updateCartCountInHeader(cart);
        }
        /* Zonder melding schoof de lade leeg of ongewijzigd open en zag de
           klant niet waarom het product er niet in zat. */
        showAddNotice((err && err.cnShopMessage) || ADD_ERROR_LABEL);
      } finally {
        finishLoading();
        if (submitBtn) submitBtn.disabled = false;
        delete form.dataset.busy;
      }
    });
  };

  /* Melding boven de producten in de lade. Verdwijnt bij de volgende
     geslaagde toevoeging of na 10 seconden. */
  let addNoticeTimer = null;
  function hideAddNotice() {
    clearTimeout(addNoticeTimer);
    const el = document.getElementById('cart-custom-add-notice');
    if (el) el.hidden = true;
  }
  function showAddNotice(text) {
    if (!cartItemsContainer || !text) return;
    let el = document.getElementById('cart-custom-add-notice');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cart-custom-add-notice';
      el.className = 'cart-custom-notice';
      el.setAttribute('role', 'alert');
      cartItemsContainer.parentNode.insertBefore(el, cartItemsContainer);
    }
    el.textContent = text;
    el.hidden = false;
    clearTimeout(addNoticeTimer);
    addNoticeTimer = setTimeout(hideAddNotice, 10000);
  }

  document.addEventListener('submit', onAddToCartCapture, { capture: true });

  // ============================
  //  PUBLIC API
  // ============================
  window.customCart = {
    open: openCart,
    close: closeCart,
    refresh: async () => {
      const cart = await fetchCart(true);
      if (cart) {
        /* Eén render — zie openCart. */
        updateCartUI(cart);
        updateCartCountInHeader(cart);
      }
    }
  };

  // ============================
  //  INITIALIZATION
  // ============================
  /* Bij het laden: de winkelwagen uit de pagina (Liquid) gebruiken als dit
     tabblad niets anders zag en de pagina niet uit de geschiedenis komt
     (terugknop). Leeg, dan is er niets te doen: geen enkel verzoek. Anders
     halen we hem op, zoals voorheen. */
  const navigationType = () => {
    try { return (performance.getEntriesByType('navigation')[0] || {}).type || ''; } catch (e) { return ''; }
  };
  const initCart = async () => {
    if (customElements.get('cart-count')) {
      await customElements.whenDefined('cart-count');
    }

    const pageCart = CFG.cart && Array.isArray(CFG.cart.items) ? CFG.cart : null;
    let seen = null;
    try { seen = sessionStorage.getItem(CART_SEEN_KEY); } catch (e) { /* geen geheugen: vertrouw de pagina */ }
    const trusted = !!pageCart && navigationType() !== 'back_forward'
      && (seen === null || seen === cartSig(pageCart));
    if (trusted && pageCart.item_count === 0) {
      rememberCartSeen(pageCart);
      return;
    }

    let cart = trusted ? await adoptCart(pageCart, true) : await fetchCart(true);

    if (cart) {
      /* Bij het laden de cadeaus in orde brengen (bv. een sessie van
         gisteren, of een oud BOGOS-cadeau van vóór de omschakeling).
         Veranderde er iets, dan ook de cart-page laten bijwerken. */
      const beforeCount = cart.item_count;
      cart = await removeOrphanedGifts(cart);
      cart = await cnEnsureFeesBeforeRender(cart);
      updateCartUI(cart);
      updateCartCountInHeader(cart);
      if (cart && cart.item_count !== beforeCount) {
        notifyCartChanged(cart, 'sync');
      }
    }
  };
  /* Zoals altijd bij DOMContentLoaded (dan draaien ook de andere uitgestelde
     scripts al, zoals bundle.js met de teller in de header). Na een
     herkansing (cnRetryScript) kan dat moment al voorbij zijn: dan meteen.
     cnDomReady zet theme.liquid. */
  if (document.readyState === 'loading' || window.cnDomReady === false) {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }

  /* ── bfcache-restore (checkout → terug-knop) ──
     De pagina komt uit de back/forward-cache met de DOM-staat van vóór
     de checkout; er vuurt géén DOMContentLoaded en dus ook geen initial
     orphan-cleanup of verse render. Cart/discount-state kan in de
     checkout gewijzigd zijn → zelfde routine als de pageload-init:
     verse fetch, cleanup, re-render, en notify zodat ook de cart-page
     section zich in sync brengt. */
  window.addEventListener('pageshow', async (e) => {
    if (!e.persisted) return;
    /* Eerst de vertrekstand opruimen: de checkout-knop stond nog op
       "bezig" en __cnCheckoutInProgress hield de cart-page tegen. Het thema
       herlaadde vroeger elke bfcache-pagina, waardoor dit nooit nodig was. */
    try {
      if (cnWatchdogTimer) { clearTimeout(cnWatchdogTimer); cnWatchdogTimer = null; }
      cnCheckoutUISweep();
      const pendingRestore = cnWatchdogRestore;
      cnWatchdogRestore = null;
      if (pendingRestore) pendingRestore();
    } catch (err) { /* knoppen herstellen is best-effort */ }
    try {
      lastCartFetchTime = 0;
      let cart = await fetchCart(true);
      if (!cart) return;
      cart = await removeOrphanedGifts(cart);
      updateCartUI(cart, null, false, false, { forceFullRender: true });
      updateCartCountInHeader(cart);
      notifyCartChanged(cart, 'sync');
    } catch (err) { /* best-effort: volgende cart-event herstelt alsnog */ }
  });

  /* ── Globale refresh-handle voor externe callers (bv. gift-picker) ──
     Cart-custom.liquid's interne fetchCart/updateCartUI zijn IIFE-scoped;
     andere snippets binnen dezelfde pagina kunnen die niet bereiken. Deze
     wrapper invalideert de fetch-time-cache, haalt verse cart-state op,
     rendert de drawer + header opnieuw. Gebruikt door cn-gift-picker
     direct na een succesvolle /cart/add.js zodat de nieuwe gift in de
     drawer verschijnt zonder dat de klant zelf hoeft te refreshen. */
  window.cnDrawerRefresh = async function () {
    try {
      lastCartFetchTime = 0;
      const cart = await fetchCart(true);
      if (cart) {
        updateCartUI(cart, null, false, false, { forceFullRender: true });
        updateCartCountInHeader(cart);
      }
      return cart;
    } catch (e) {
      return null;
    }
  };

  /* Gedeelde grace-aware orphan-cleaner zodat sections/cart.liquid exact
     dezelfde regels gebruikt (geen gedupliceerde, afwijkende inline kopie). */
  window.cnRemoveOrphanedGifts = removeOrphanedGifts;
})();
